import * as Types from '../../../sitos-x-api.types.g';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any; }
  /**
   * 
   * Represents a duration of time (see 'j' pattern https://nodatime.org/3.0.x/userguide/duration-patterns)
   * 
   * The format is:  -H:mm:ss.FFFFFFFFF
   * 
   * H - total hours (can be >=24)
   * mm - minutes (0-59)
   * ss - seconds (0-59)
   * FFFFFFFF - fractions of a second
   *
   */
  Duration: { input: any; output: any; }
  /**
   *
   * A UTC timestamp in ISO 8601 format (invariant culture). May includes fractions of seconds.
   *
   * Examples:
   *
   * - `2020-12-24T16:23:44,0003Z`
   *
   */
  Instant: { input: any; output: any; }
  /**
   *
   * Keys must conform to the regular expression `/^[A-Z][_A-Z0-9]*$/`
   *
   */
  Key: { input: any; output: any; }
  /**
   *
   * A local date without timezone, in ISO 8601 format (yyyy-mm-dd).
   *
   * Examples:
   *
   * - `2020-12-24`
   * - `2020-01-01`
   *
   */
  LocalDate: { input: any; output: any; }
  /**
   *
   * A local time without timezone or date, in 24 hour format.
   *
   * Examples:
   *
   * - `00:43:23`
   * - `07:55:30`
   * - `18:30:20`
   *
   */
  LocalTime: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  /**
   *
   * UUID in all lowercase letters, with '-' separated for readability. Example: ac1ac624-4b13-4dfb-9cb3-0d84ba7e5767
   *
   */
  UUID: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
  Url: { input: any; output: any; }
  Uuid: { input: any; output: any; }
};

export type ActivateBadgesInput = {
  idOrKey: IdOrKeyInput;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivateCatalogForGroupsInput = {
  catalogAudience: CatalogAudienceEnum;
  groups?: InputMaybe<Array<IdOrKeyInput>>;
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivateCatalogInput = {
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  showInCatalog: Scalars['Boolean']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivateMediaInput = {
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  status: PublishStatus;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type AddUnitInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  deleteFile?: InputMaybe<Scalars['Boolean']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type AddUnitLearningManagersInput = {
  unitUuid?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type AssignCourseGroupInput = {
  courseUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<UpsertLinksInput>;
};

export enum AssignedContentState {
  Completed = 'COMPLETED',
  Inactive = 'INACTIVE',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export type AssignmentTokenDto = {
  __typename?: 'AssignmentTokenDTO';
  hasRoles: Scalars['Boolean']['output'];
  payload?: Maybe<Scalars['String']['output']>;
  person?: Maybe<PersonAssignmnetTokenDto>;
};

export enum AssignmentTypeEnum {
  Automatic = 'AUTOMATIC',
  Standard = 'STANDARD'
}

/** Assistant conversation token return object */
export type AssistantGql = {
  __typename?: 'AssistantGQL';
  adminVideosUrl?: Maybe<Scalars['String']['output']>;
  assistantApiUrl?: Maybe<Scalars['String']['output']>;
  learnerSupportEmail?: Maybe<Scalars['String']['output']>;
  learnerVideosUrl?: Maybe<Scalars['String']['output']>;
};

export type AttachmentInfo = {
  __typename?: 'AttachmentInfo';
  base64?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
};

export type AttemptGql = {
  __typename?: 'AttemptGQL';
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  scoItem?: Maybe<Scorm12Item>;
  uuid: Scalars['UUID']['output'];
};

/** Mutations creating and upserting authorization tokens and personalized tokens */
export type AuthorizationTokenMutation = {
  __typename?: 'AuthorizationTokenMutation';
  create: Scalars['String']['output'];
  /** Creates personized token that will be send by email */
  createPersonizedToken: Scalars['String']['output'];
  /** Convenience property, will always return '##' */
  id: Scalars['String']['output'];
};


/** Mutations creating and upserting authorization tokens and personalized tokens */
export type AuthorizationTokenMutationCreateArgs = {
  input: CreateAuthorizationTokenInput;
};


/** Mutations creating and upserting authorization tokens and personalized tokens */
export type AuthorizationTokenMutationCreatePersonizedTokenArgs = {
  input: CreateAuthorizationPersonizedTokenInput;
};

/** Average Learning Time Widget */
export type AverageLearningTimeWidget = {
  __typename?: 'AverageLearningTimeWidget';
  friday?: Maybe<Day>;
  monday?: Maybe<Day>;
  saturday?: Maybe<Day>;
  sunday?: Maybe<Day>;
  thursday?: Maybe<Day>;
  tuesday?: Maybe<Day>;
  wednesday?: Maybe<Day>;
};

/** Badge Collection */
export type BadgeCollection = {
  __typename?: 'BadgeCollection';
  /** Badge present in course */
  courseHasBadge: Scalars['Boolean']['output'];
  /** Course uuid */
  courseUuid: Scalars['String']['output'];
  /** Course name */
  name: LangString;
};

export type BadgeDto = {
  __typename?: 'BadgeDto';
  description?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isSystemBadge: Scalars['Boolean']['output'];
  series?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type BadgeNotificationsDto = {
  __typename?: 'BadgeNotificationsDto';
  badgeId: Scalars['Int']['output'];
  badgeType?: Maybe<BadgeTypeEnum>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  notificationShown: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** GraphQL mutation to upsert badges notifications */
export type BadgeNotificationsMutation = {
  __typename?: 'BadgeNotificationsMutation';
  updateBadgeNotifications?: Maybe<Badges_Notifications>;
};


/** GraphQL mutation to upsert badges notifications */
export type BadgeNotificationsMutationUpdateBadgeNotificationsArgs = {
  input?: InputMaybe<UpsertBadgeNotificationsInput>;
};

export enum BadgeTypeEnum {
  Badge = 'BADGE',
  Catalog = 'CATALOG',
  Completion = 'COMPLETION',
  Individual = 'INDIVIDUAL',
  Login = 'LOGIN'
}

/** The Badges */
export type Badges = {
  __typename?: 'Badges';
  /** Badge Type */
  badgeType: BadgeTypeEnum;
  /** Description in German */
  descriptionDe?: Maybe<Scalars['String']['output']>;
  /** Description in English */
  descriptionEn?: Maybe<Scalars['String']['output']>;
  /** Display Name */
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Image Url */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Is Active Badge */
  isActive: Scalars['Boolean']['output'];
  /** Is Edit Badge */
  isEdited: Scalars['Boolean']['output'];
  /** Is System Badge */
  isSystemBadge: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  /** German Series */
  seriesDe?: Maybe<Scalars['String']['output']>;
  /** English Series */
  seriesEn?: Maybe<Scalars['String']['output']>;
  /** System Badge Type */
  systemBadgeType?: Maybe<SystemBadgeTypesEnum>;
  /** Title in German */
  titleDe?: Maybe<Scalars['String']['output']>;
  /** Title in English */
  titleEn?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  /** Primary */
  uuidPrimary?: Maybe<Scalars['String']['output']>;
};

/** GraphQL mutation to upsert, activate/deactivate, reset and delete badges  */
export type BadgesMutation = {
  __typename?: 'BadgesMutation';
  activateDeactivateBadge: Badges;
  removeCourseBadge: Scalars['Boolean']['output'];
  resetSystemBadge: Scalars['Boolean']['output'];
  updateSystemBadge?: Maybe<Badges>;
  upsertCourseBadge?: Maybe<Badges>;
  upsertSystemBadge?: Maybe<Badges>;
};


/** GraphQL mutation to upsert, activate/deactivate, reset and delete badges  */
export type BadgesMutationActivateDeactivateBadgeArgs = {
  input: ActivateBadgesInput;
};


/** GraphQL mutation to upsert, activate/deactivate, reset and delete badges  */
export type BadgesMutationRemoveCourseBadgeArgs = {
  input: UpsertRef2Input;
};


/** GraphQL mutation to upsert, activate/deactivate, reset and delete badges  */
export type BadgesMutationResetSystemBadgeArgs = {
  input: UpsertRef2Input;
};


/** GraphQL mutation to upsert, activate/deactivate, reset and delete badges  */
export type BadgesMutationUpdateSystemBadgeArgs = {
  input: UpsertBadgeInput;
};


/** GraphQL mutation to upsert, activate/deactivate, reset and delete badges  */
export type BadgesMutationUpsertCourseBadgeArgs = {
  input: UpsertBadgeInput;
};


/** GraphQL mutation to upsert, activate/deactivate, reset and delete badges  */
export type BadgesMutationUpsertSystemBadgeArgs = {
  input: UpsertBadgeInput;
};

/** The Badge Notifications */
export type Badges_Notifications = {
  __typename?: 'Badges_Notifications';
  /** Badge Id */
  badgeId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Image Url */
  imageUrl?: Maybe<Scalars['String']['output']>;
  key: Scalars['Key']['output'];
  /** Notification Shown */
  notificationShown: Scalars['Boolean']['output'];
  /** User Id */
  userId: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
};

export type BookCourseInput = {
  catalog?: InputMaybe<Scalars['Boolean']['input']>;
  course: IdOrKeyInput;
  dateOfReminder?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Instant']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  intervall?: InputMaybe<IntervallTypeEnum>;
  intervallEndDate?: InputMaybe<Scalars['Instant']['input']>;
  removed?: InputMaybe<Scalars['Boolean']['input']>;
  roleLinks?: InputMaybe<Array<InputMaybe<UpsertRoleAssignmentInput>>>;
  startDate?: InputMaybe<Scalars['Instant']['input']>;
};

export type BulkAcceptanceListInput = {
  userStatus?: InputMaybe<UserStatus>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkActivateCatalogInput = {
  courseUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showInCatalog: Scalars['Boolean']['input'];
};

export type BulkActivateMediaInput = {
  courseUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PublishStatus;
};

export type BulkAnonymizeUserInput = {
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkDeleteCategoryInput = {
  categoryUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkDeleteMediaInput = {
  courseUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkDeleteScorm12ItemInput = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkDeleteUserInput = {
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkExportUsersInput = {
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkInsertReuseNuggetInput = {
  courseId: Scalars['Int']['input'];
  itemUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentId: Scalars['Int']['input'];
};

export type BulkResendVerificationEmailInput = {
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkUpdateGroupStatusInput = {
  groupUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: GroupStatus;
};

export type BulkUpdateMediaCategoriesInput = {
  categoriesUuid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  courseUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkUpdateMediaGroupsInput = {
  accessAfterUnit?: InputMaybe<RelativeTimeUnitEnum>;
  accessAfterValue?: InputMaybe<Scalars['Int']['input']>;
  accessDurationUnit?: InputMaybe<RelativeTimeUnitEnum>;
  accessDurationValue?: InputMaybe<Scalars['Int']['input']>;
  activateMedia?: InputMaybe<Scalars['Boolean']['input']>;
  assignmentType?: InputMaybe<AssignmentTypeEnum>;
  completionNotification: Scalars['Boolean']['input'];
  courseUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateOfReminder?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  groups?: InputMaybe<UpsertLinksInput>;
  intervall?: InputMaybe<IntervallTypeEnum>;
  intervallEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  newCourseNotification: Scalars['Boolean']['input'];
  roleLinks?: InputMaybe<Array<InputMaybe<UpsertRoleAssignmentInput>>>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type BulkUpdateUserGroupsInput = {
  groups?: InputMaybe<UpsertLinksInput>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkUpdateUserStatusInput = {
  status: UserStatus;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CalendarData = {
  __typename?: 'CalendarData';
  color?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Scorm12Course>;
  courseTitle?: Maybe<LangString>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
};

export enum CatalogAudienceEnum {
  AllUsers = 'ALL_USERS',
  Groups = 'GROUPS'
}

export enum CatalogSortingItems {
  LearningTimeLongShort = 'LEARNING_TIME_LONG_SHORT',
  LearningTimeShortLong = 'LEARNING_TIME_SHORT_LONG',
  ReleaseDateNewOld = 'RELEASE_DATE_NEW_OLD',
  ReleaseDateOldNew = 'RELEASE_DATE_OLD_NEW',
  TitleAz = 'TITLE_AZ',
  TitleZa = 'TITLE_ZA'
}

/** Catelogue favourite for user */
export type CatalogueFavourite = {
  __typename?: 'CatalogueFavourite';
  /** Course */
  courseName: LangString;
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  /** User */
  userFullName: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

/** Mutation for updating/upserting and removing Catalog Favorites */
export type CatalogueFavouriteMutation = {
  __typename?: 'CatalogueFavouriteMutation';
  upsert: CatalogueFavourite;
};


/** Mutation for updating/upserting and removing Catalog Favorites */
export type CatalogueFavouriteMutationUpsertArgs = {
  input: FavouriteCatelogueItemInput;
};

/** A category */
export type Category = {
  __typename?: 'Category';
  /** Assigned media count on the categories */
  assignedMediaCount: Scalars['Int']['output'];
  /** Categories assigned to the course */
  categories?: Maybe<Array<Maybe<Scorm12Course>>>;
  /** Defines description of the category */
  description: LangString;
  /** Categories assigned to the enrolled course */
  enrolledCategories?: Maybe<Array<Maybe<Scorm12EnrolledCourse>>>;
  /** Icon URL */
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  /** Defines name of the category */
  name: LangString;
  uuid: Scalars['UUID']['output'];
};

export type CategoryDto = {
  __typename?: 'CategoryDto';
  courseCount: Scalars['Int']['output'];
  description?: Maybe<LangString>;
  enrolledCategories?: Maybe<Array<Maybe<Scorm12EnrolledCourseDto>>>;
  enrolledCategoriesCount: Scalars['Int']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Array<Scalars['Byte']['output']>>;
  imageType?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<LangString>;
  totalCategories: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
};

/** GraphQL mutation to update, remove, or bulk remove a category */
export type CategoryMutation = {
  __typename?: 'CategoryMutation';
  bulkRemove: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
  reorderCategoryMedias?: Maybe<Category>;
  upsert: Category;
};


/** GraphQL mutation to update, remove, or bulk remove a category */
export type CategoryMutationBulkRemoveArgs = {
  input: BulkDeleteCategoryInput;
};


/** GraphQL mutation to update, remove, or bulk remove a category */
export type CategoryMutationRemoveArgs = {
  input: UpsertRef2Input;
};


/** GraphQL mutation to update, remove, or bulk remove a category */
export type CategoryMutationReorderCategoryMediasArgs = {
  input: UpdateCategoryMediasOrderInput;
};


/** GraphQL mutation to update, remove, or bulk remove a category */
export type CategoryMutationUpsertArgs = {
  input: UpsertCategoryInput;
};

/** A category */
export type CategoryRefactor = {
  __typename?: 'CategoryRefactor';
  /** Assigned media count on the categories */
  assignedMediaCount: Scalars['Int']['output'];
  /** Defines key of the category */
  key: Scalars['String']['output'];
  /** Defines name of the category */
  name: LangString;
  /** Defines uuid of the category */
  uuid: Scalars['UUID']['output'];
};

/** Generate Base64 string for certificate */
export type CertGenerateGql = {
  __typename?: 'CertGenerateGQL';
  base64String?: Maybe<Scalars['String']['output']>;
};

/** Generate Base64 string for certificate preview */
export type CertPreviewGql = {
  __typename?: 'CertPreviewGQL';
  htmlText?: Maybe<Scalars['String']['output']>;
};

/** A certificate */
export type Certificate = {
  __typename?: 'Certificate';
  /** Completion date */
  completionDate?: Maybe<Scalars['String']['output']>;
  /** Course name assigned certificate */
  courseName?: Maybe<LangString>;
  /** Course uuid assigned certificate */
  courseUuid: Scalars['UUID']['output'];
  /** Enrolled course uuid assigned certificate */
  enrolledCourseUuid: Scalars['UUID']['output'];
  /** German heading */
  headingDe?: Maybe<Scalars['String']['output']>;
  /** English heading */
  headingEn?: Maybe<Scalars['String']['output']>;
  /** Swahili heading */
  headingSw?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  /** Languages */
  languages: Scalars['Int']['output'];
  /** Logo URL */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Media items count */
  mediaItemsCount: Scalars['Int']['output'];
  systemLanguage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** German text */
  textDe?: Maybe<Scalars['String']['output']>;
  /** English text */
  textEn?: Maybe<Scalars['String']['output']>;
  /** Swahili text */
  textSw?: Maybe<Scalars['String']['output']>;
  /** English text */
  title?: Maybe<Scalars['String']['output']>;
  /** Defines title of certificate in German */
  titleDe: Scalars['String']['output'];
  /** Defines title of certificate in English */
  titleEn: Scalars['String']['output'];
  /** Defines title of certificate in Swahili */
  titleSw?: Maybe<Scalars['String']['output']>;
  /** Type */
  type: CertificateTypeEnum;
  uuid: Scalars['UUID']['output'];
};

export type CertificateDownloadInput = {
  courseUuid?: InputMaybe<Scalars['String']['input']>;
  enrolledCourseUuid: Scalars['UUID']['input'];
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CertificateDto = {
  __typename?: 'CertificateDto';
  createdDate: Scalars['Instant']['output'];
  deletedDate?: Maybe<Scalars['Instant']['output']>;
  headingDe?: Maybe<Scalars['String']['output']>;
  headingEn?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  textDe?: Maybe<Scalars['String']['output']>;
  textEn?: Maybe<Scalars['String']['output']>;
  titleDe?: Maybe<Scalars['String']['output']>;
  titleEn?: Maybe<Scalars['String']['output']>;
  type: CertificateTypeEnum;
  updatedDate: Scalars['Instant']['output'];
  uuid: Scalars['UUID']['output'];
};

export type CertificatePreviewInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypeEnum;
};

export enum CertificateTypeEnum {
  Template1 = 'TEMPLATE1',
  Template3 = 'TEMPLATE3'
}

/** GraphQL mutation to update, upsert, remove or duplicate a certificate */
export type CertificatesMutation = {
  __typename?: 'CertificatesMutation';
  duplicate?: Maybe<Certificate>;
  remove: Scalars['Boolean']['output'];
  upsert: Certificate;
};


/** GraphQL mutation to update, upsert, remove or duplicate a certificate */
export type CertificatesMutationDuplicateArgs = {
  input: UpsertRef2Input;
};


/** GraphQL mutation to update, upsert, remove or duplicate a certificate */
export type CertificatesMutationRemoveArgs = {
  input: UpsertRef2Input;
};


/** GraphQL mutation to update, upsert, remove or duplicate a certificate */
export type CertificatesMutationUpsertArgs = {
  input: UpsertCertificateInput;
};

export type ChangeCourseOwnerInput = {
  coursesUuid: Array<InputMaybe<IdOrKeyInput>>;
  newOwnerUuid: IdOrKeyInput;
};

export type CommitScorm12AttemptInput = {
  commitSequence?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scorm12_Entry>;
  file?: InputMaybe<Scalars['String']['input']>;
  idOrKey: IdOrKeyInput;
  lessonLocation?: InputMaybe<Scalars['String']['input']>;
  lessonStatus?: InputMaybe<Scorm12_LessonStatus>;
  masteryScore?: InputMaybe<Scalars['Float']['input']>;
  scoreMax?: InputMaybe<Scalars['Float']['input']>;
  scoreMin?: InputMaybe<Scalars['Float']['input']>;
  scoreRaw?: InputMaybe<Scalars['Float']['input']>;
  sessionApiKey: Scalars['String']['input'];
  suspendData?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['Duration']['input']>;
};

export type CompletionDay = {
  __typename?: 'CompletionDay';
  completions: Scalars['Int']['output'];
  date?: Maybe<Scalars['String']['output']>;
  dayOfWeek?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<Maybe<CompletionDetails>>>;
};

export type CompletionDetails = {
  __typename?: 'CompletionDetails';
  courseId: Scalars['UUID']['output'];
  courseName?: Maybe<LangString>;
  users?: Maybe<Array<Maybe<CompletionUsers>>>;
  usersCount: Scalars['Int']['output'];
};

export type CompletionUsers = {
  __typename?: 'CompletionUsers';
  name?: Maybe<Scalars['String']['output']>;
};

/** Config object */
export type Config = {
  __typename?: 'Config';
  /** Logo URL */
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Key */
  key: Scalars['String']['output'];
  /** Uuid */
  uuid: Scalars['String']['output'];
};

/** Mutation for upserting configuration data */
export type ConfigsMutation = {
  __typename?: 'ConfigsMutation';
  enableAiInstruction: CourseUploadAccessibility;
  enableBadge: CourseUploadAccessibility;
  enableCourseUpload: CourseUploadAccessibility;
  enableLtiTool: CourseUploadAccessibility;
  enableTask: CourseUploadAccessibility;
  enableZulipChat: CourseUploadAccessibility;
  switchCalendarWidget: CourseUploadAccessibility;
  switchChatbot: CourseUploadAccessibility;
  switchEvaluation: CourseUploadAccessibility;
  switchLearningPath: CourseUploadAccessibility;
  switchMailingStatus: CourseUploadAccessibility;
  switchMaintenance: CourseUploadAccessibility;
  switchParent: CourseUploadAccessibility;
  switchRecommendation: CourseUploadAccessibility;
  switchUsermanagementByExternalIdm: CourseUploadAccessibility;
  upsert: Config;
};


/** Mutation for upserting configuration data */
export type ConfigsMutationEnableAiInstructionArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationEnableBadgeArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationEnableCourseUploadArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationEnableLtiToolArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationEnableTaskArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationEnableZulipChatArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationSwitchCalendarWidgetArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationSwitchChatbotArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationSwitchEvaluationArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationSwitchLearningPathArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationSwitchMailingStatusArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationSwitchMaintenanceArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationSwitchParentArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationSwitchRecommendationArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationSwitchUsermanagementByExternalIdmArgs = {
  input: Scalars['Boolean']['input'];
};


/** Mutation for upserting configuration data */
export type ConfigsMutationUpsertArgs = {
  input: UpsertConfigInput;
};

export enum ContentAssignmentSource {
  Catalogue = 'CATALOGUE',
  Group = 'GROUP',
  Manual = 'MANUAL'
}

export type ContentGroup = {
  __typename?: 'ContentGroup';
  isGeneral: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type ContentOverviewFilterInput = {
  assignedUsersMax?: InputMaybe<Scalars['Int']['input']>;
  assignedUsersMin?: InputMaybe<Scalars['Int']['input']>;
  completedMax?: InputMaybe<Scalars['Int']['input']>;
  completedMin?: InputMaybe<Scalars['Int']['input']>;
  completionRateMax?: InputMaybe<Scalars['Float']['input']>;
  completionRateMin?: InputMaybe<Scalars['Float']['input']>;
  createdFrom?: InputMaybe<Scalars['Instant']['input']>;
  createdTo?: InputMaybe<Scalars['Instant']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  lastViewFrom?: InputMaybe<Scalars['Instant']['input']>;
  lastViewTo?: InputMaybe<Scalars['Instant']['input']>;
  mediaTypes?: InputMaybe<Array<MediaType>>;
  notStartedMax?: InputMaybe<Scalars['Int']['input']>;
  notStartedMin?: InputMaybe<Scalars['Int']['input']>;
  startedMax?: InputMaybe<Scalars['Int']['input']>;
  startedMin?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewsMax?: InputMaybe<Scalars['Int']['input']>;
  viewsMin?: InputMaybe<Scalars['Int']['input']>;
};

/** One page of the content overview report */
export type ContentOverviewPage = {
  __typename?: 'ContentOverviewPage';
  /** Rows of the requested page */
  items: Array<Maybe<ContentOverviewRow>>;
  /** KPI figures over all rows matching search and filter */
  summary: ContentOverviewSummary;
  /** Number of rows matching search and filter (all pages) */
  totalCount: Scalars['Int']['output'];
};

/** One course of the content overview report */
export type ContentOverviewRow = {
  __typename?: 'ContentOverviewRow';
  /** Distinct groups through which the counted learners are enrolled (any assignment status) */
  assignedGroups: Scalars['Int']['output'];
  /** Distinct visible learners (direct, group and catalog assignments) = notStarted + started + completed */
  assignedUsers: Scalars['Int']['output'];
  /** Learners whose current activation is completed */
  completed: Scalars['Int']['output'];
  /** completed / assignedUsers in percent, null when nothing is assigned */
  completionRate?: Maybe<Scalars['Float']['output']>;
  createdDate: Scalars['Instant']['output'];
  /** Course key */
  id: Scalars['String']['output'];
  itemIdentifier?: Maybe<Scalars['String']['output']>;
  /** Last time the course was opened, null if never */
  lastView?: Maybe<Scalars['Instant']['output']>;
  /** Media type of the root SCO */
  mediaType: MediaType;
  /** Learners whose current activation is not started */
  notStarted: Scalars['Int']['output'];
  /** Learners whose current activation is started */
  started: Scalars['Int']['output'];
  /** Title localized for the current user */
  title: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
  /** Number of calls (same as mediaStatistics numberOfCalls) */
  views: Scalars['Int']['output'];
};

export enum ContentOverviewSortField {
  AssignedGroups = 'ASSIGNED_GROUPS',
  AssignedUsers = 'ASSIGNED_USERS',
  Completed = 'COMPLETED',
  CompletionRate = 'COMPLETION_RATE',
  CreatedDate = 'CREATED_DATE',
  LastView = 'LAST_VIEW',
  MediaType = 'MEDIA_TYPE',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED',
  Title = 'TITLE',
  Views = 'VIEWS'
}

export type ContentOverviewSortInput = {
  direction: SortDirection;
  field: ContentOverviewSortField;
};

/** KPI figures of the content overview report */
export type ContentOverviewSummary = {
  __typename?: 'ContentOverviewSummary';
  /** Number of matching courses with at least one assigned user */
  assignedContent: Scalars['Int']['output'];
  /** Sum of the completed learners of all matching courses */
  completed: Scalars['Int']['output'];
  /** Completed learners / assigned users over all matching courses in percent, 0 when nothing is assigned */
  completionRate: Scalars['Float']['output'];
  /** Number of matching courses */
  totalContent: Scalars['Int']['output'];
};

/** Represents a context that groups launchers. */
export type Context = {
  __typename?: 'Context';
  /** The unique key of the context. */
  key: Scalars['String']['output'];
  /** The localized label of the context. */
  label: Scalars['String']['output'];
  /** The UUID of the context. */
  uuid: Scalars['String']['output'];
};

export enum CourseCompletionStatus {
  All = 'ALL',
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export type CourseCompletionsGql = {
  __typename?: 'CourseCompletionsGQL';
  friday?: Maybe<CompletionDay>;
  monday?: Maybe<CompletionDay>;
  saturday?: Maybe<CompletionDay>;
  sunday?: Maybe<CompletionDay>;
  thursday?: Maybe<CompletionDay>;
  tuesday?: Maybe<CompletionDay>;
  wednesday?: Maybe<CompletionDay>;
};

export type CourseConnectionGql = {
  __typename?: 'CourseConnectionGQL';
  edges: Array<CourseEdgeGql>;
  nodes: Array<Scorm12Course>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseConnectionGqlFilterInput = {
  and?: InputMaybe<Array<CourseConnectionGqlFilterInput>>;
  or?: InputMaybe<Array<CourseConnectionGqlFilterInput>>;
  totalCount?: InputMaybe<IntOperationFilterInput>;
};

export type CourseConnectionGqlSortInput = {
  totalCount?: InputMaybe<SortEnumType>;
};

export type CourseEdgeGql = {
  __typename?: 'CourseEdgeGQL';
  cursor: Scalars['String']['output'];
  node: Scorm12Course;
};

export type CourseEvaluationDto = {
  __typename?: 'CourseEvaluationDto';
  comment?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Scorm12CourseDto>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['Int']['output'];
  isAnonym: Scalars['Boolean']['output'];
  isDeactivated: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Float']['output'];
  user?: Maybe<UserDto>;
  uuid: Scalars['UUID']['output'];
};

export type CourseEvaluationGql = {
  __typename?: 'CourseEvaluationGQL';
  /** Evaluation comment */
  comment: Scalars['String']['output'];
  /** Course */
  course?: Maybe<Scorm12Course>;
  /** Evaluation CreatedAt */
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  /** Evaluation IsAnonym */
  isAnonym: Scalars['Boolean']['output'];
  /** Evaluation IsDeactivated */
  isDeactivated: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  /** Evaluation Rating */
  rating: Scalars['Float']['output'];
  /** Evaluation User */
  user: User;
  uuid: Scalars['UUID']['output'];
};

export type CourseEvaluationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  courseUuid?: InputMaybe<Scalars['String']['input']>;
  idOrKey: IdOrKeyInput;
  isAnonym: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  rating: Scalars['Float']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** GraphQL mutation for upserting course evaluation */
export type CourseEvaluationMutation = {
  __typename?: 'CourseEvaluationMutation';
  deactivateEvaluation: CourseEvaluationGql;
  remove: Scalars['Boolean']['output'];
  updateEvaluation: CourseEvaluationGql;
  upsert: CourseEvaluationGql;
};


/** GraphQL mutation for upserting course evaluation */
export type CourseEvaluationMutationDeactivateEvaluationArgs = {
  input: DeactivateCourseEvaluationInput;
};


/** GraphQL mutation for upserting course evaluation */
export type CourseEvaluationMutationRemoveArgs = {
  input: UpsertRef2Input;
};


/** GraphQL mutation for upserting course evaluation */
export type CourseEvaluationMutationUpdateEvaluationArgs = {
  input: UpdateCourseEvaluationInput;
};


/** GraphQL mutation for upserting course evaluation */
export type CourseEvaluationMutationUpsertArgs = {
  input: CourseEvaluationInput;
};

/** GraphQL mutation for updateing and upserting favorite courses */
export type CourseFavouriteMutation = {
  __typename?: 'CourseFavouriteMutation';
  upsert: Scorm12EnrolledCourse;
};


/** GraphQL mutation for updateing and upserting favorite courses */
export type CourseFavouriteMutationUpsertArgs = {
  input: UpdateCourseFavouriteInput;
};

/** Course history and last visited Widget */
export type CourseHistoryAndLastVisitedWidget = {
  __typename?: 'CourseHistoryAndLastVisitedWidget';
  /** Last accessed course date */
  completionDate?: Maybe<Scalars['String']['output']>;
  /** Course uuid */
  courseUuid: Scalars['String']['output'];
  /** Enrolled course uuid */
  enrolledCourseUuid: Scalars['String']['output'];
  /**
   * Course image
   * @deprecated Use imageUrl
   */
  image?: Maybe<Scalars['String']['output']>;
  /** Cacheable, public tile image URL. Null when the course has no image. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Course name */
  name: LangString;
};

/** Course Upload Accessibility object */
export type CourseUploadAccessibility = {
  __typename?: 'CourseUploadAccessibility';
  id: Scalars['ID']['output'];
  /** IsEnabled */
  isEnabled: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  uuid: Scalars['UUID']['output'];
};

export enum CourseUploadStatus {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  PartialFinished = 'PARTIAL_FINISHED',
  Running = 'RUNNING'
}

export type CourseVersionGql = {
  __typename?: 'CourseVersionGQL';
  /** Returns if the learning path draft can be deleted */
  canBeDeleted: Scalars['Boolean']['output'];
  /** Returns number of nuggets */
  countOfNuggets: Scalars['Int']['output'];
  /** Defines date of course creation */
  dateOfCreation: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  /** Items added count */
  itemsAdded: Scalars['Int']['output'];
  /** Items removed count */
  itemsRemoved: Scalars['Int']['output'];
  key: Scalars['Key']['output'];
  /** Learning path status */
  status?: Maybe<LearningPathStatusEnum>;
  /** Defines date of course update */
  updatedDate?: Maybe<Scalars['Instant']['output']>;
  uuid: Scalars['UUID']['output'];
  /** Version number */
  version: Scalars['String']['output'];
};

export type CreateAuthorizationPersonizedTokenInput = {
  /** Token expiration date */
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Token expiration time */
  expirationTime?: InputMaybe<Scalars['LocalTime']['input']>;
  personLink?: InputMaybe<IdOrKeyInput>;
};

export type CreateAuthorizationTokenInput = {
  /** Token expiration date */
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Token expiration time */
  expirationTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** List of OrgGroup names */
  orgGroups?: InputMaybe<Array<InputMaybe<UpsertOrgGroupsInput>>>;
  /** List of roles names */
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum DashboardFilter {
  All = 'ALL',
  Catalog = 'CATALOG',
  LearningSpace = 'LEARNING_SPACE'
}

export enum DashboardMode {
  Default = 'DEFAULT',
  Microlearning = 'MICROLEARNING'
}

export type DashboardStatisticDto = {
  __typename?: 'DashboardStatisticDTO';
  assignedCourses?: Maybe<Scalars['Int']['output']>;
  bookedCourses?: Maybe<Scalars['Int']['output']>;
  catalogCourses?: Maybe<Scalars['Int']['output']>;
  finishedCourses?: Maybe<Scalars['Int']['output']>;
  finishedMandatoryCourses?: Maybe<Scalars['Int']['output']>;
  mandatoryCourses?: Maybe<Scalars['Int']['output']>;
  startedCourses?: Maybe<Scalars['Int']['output']>;
};

export type Day = {
  __typename?: 'Day';
  averageLearningTimeNumber: Scalars['Decimal']['output'];
  averageLearningTimeString?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dayOfWeek?: Maybe<Scalars['String']['output']>;
  onlineUsers: Scalars['Int']['output'];
};

export type DeactivateCourseEvaluationInput = {
  idOrKey: IdOrKeyInput;
  isDeactivated: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeactivateMediaInput = {
  courseUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupUuid?: InputMaybe<Scalars['String']['input']>;
};

/** A Default unit */
export type Default_Unit = {
  __typename?: 'Default_Unit';
  /** color */
  color?: Maybe<Scalars['String']['output']>;
  /** Unit id to display */
  displayedId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Defines if unit is active */
  isActive: Scalars['Boolean']['output'];
  /** Is general unit */
  isGeneral: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  /** Logo URL */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Defines name of the unit */
  name: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type DeleteMediaInput = {
  idOrKey: IdOrKeyInput;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeleteUnitLearningManagerInput = {
  unitId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DragAndDropInputsInput = {
  courseId: Scalars['Int']['input'];
  idOrKey: IdOrKeyInput;
  isChapter: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  order: Scalars['Int']['input'];
  parentId: Scalars['Int']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export enum EmailTemplateEnum {
  BookNewCourse = 'BOOK_NEW_COURSE',
  CourseCompleted = 'COURSE_COMPLETED',
  MandatoryNotification = 'MANDATORY_NOTIFICATION',
  NewCoursesBulkAssignment = 'NEW_COURSES_BULK_ASSIGNMENT',
  NonCompletionReportNotification = 'NON_COMPLETION_REPORT_NOTIFICATION',
  RecurringNotification = 'RECURRING_NOTIFICATION',
  ReminderNotification = 'REMINDER_NOTIFICATION',
  ResetPassword = 'RESET_PASSWORD',
  TemporaryNotification = 'TEMPORARY_NOTIFICATION',
  UserInvitation = 'USER_INVITATION'
}

export type EnrollStudentInput = {
  course: IdOrKeyInput;
  student: IdOrKeyInput;
};

/** GraphQL mutation for updating enrolled course entity */
export type EnrolledCourseMutation = {
  __typename?: 'EnrolledCourseMutation';
  completeCourse: Scalars['Boolean']['output'];
  completeCourseManually: Scalars['Boolean']['output'];
  resetStatistic: Scalars['Boolean']['output'];
  skipCelebrate: Scalars['Boolean']['output'];
};


/** GraphQL mutation for updating enrolled course entity */
export type EnrolledCourseMutationCompleteCourseArgs = {
  enrolledCourseIdentifier: IdOrKeyInput;
};


/** GraphQL mutation for updating enrolled course entity */
export type EnrolledCourseMutationCompleteCourseManuallyArgs = {
  enrolledCourseIdentifier: IdOrKeyInput;
  enrolledUserIdentifier: IdOrKeyInput;
};


/** GraphQL mutation for updating enrolled course entity */
export type EnrolledCourseMutationResetStatisticArgs = {
  enrolledCourseIdentifier: IdOrKeyInput;
  enrolledUserIdentifier: IdOrKeyInput;
};


/** GraphQL mutation for updating enrolled course entity */
export type EnrolledCourseMutationSkipCelebrateArgs = {
  enrolledCourseIdentifier: IdOrKeyInput;
};

export enum EnrolledCourseSorting {
  AlphabeticalAsc = 'ALPHABETICAL_ASC',
  AlphabeticalDesc = 'ALPHABETICAL_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  Importance = 'IMPORTANCE',
  RatingAsc = 'RATING_ASC',
  RatingDesc = 'RATING_DESC'
}

export type EnrolledItemFilterInput = {
  manifestIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Scorm item event */
export type Event = {
  __typename?: 'Event';
  agenda?: Maybe<Scalars['String']['output']>;
  agendaName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Instant']['output']>;
  endTime?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['ID']['output'];
  isPresent?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['Key']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Instant']['output'];
  startTime?: Maybe<Scalars['Instant']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type EventDtoInput = {
  agendaName?: InputMaybe<Scalars['String']['input']>;
  agendaPath?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Instant']['input'];
  endTime?: InputMaybe<Scalars['Instant']['input']>;
  isPresent?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizer: Scalars['String']['input'];
  startDate: Scalars['Instant']['input'];
  startTime?: InputMaybe<Scalars['Instant']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type ExportBase64Gql = {
  __typename?: 'ExportBase64GQL';
  base64String?: Maybe<Scalars['String']['output']>;
};

export type ExportRecurringInput = {
  course: IdOrKeyInput;
  user: IdOrKeyInput;
};

export type FavouriteCatelogueItemInput = {
  course: IdOrKeyInput;
  favourite: Scalars['Boolean']['input'];
};

export type FileInfoResult = {
  __typename?: 'FileInfoResult';
  fileName?: Maybe<Scalars['String']['output']>;
  fileNameSubTitle?: Maybe<Scalars['String']['output']>;
  fileSize: Scalars['Long']['output'];
  loopToPlay?: Maybe<Scalars['Boolean']['output']>;
};

export type FileInfoReturn = {
  __typename?: 'FileInfoReturn';
  category?: Maybe<Scalars['String']['output']>;
  dataFromLMS?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isMSCO: Scalars['Boolean']['output'];
  learningTime?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A group */
export type Group = {
  __typename?: 'Group';
  /** Assigned media */
  assignedMedia: Scalars['Int']['output'];
  /** Assigned media details */
  assignedMediaDetails?: Maybe<MediaDetailsStatisticsGql>;
  /** Media assigned to the group */
  assignedMediaItems: Array<Maybe<Scorm12Course>>;
  /** Assigned unit id */
  assignedUnitId: Scalars['Int']['output'];
  /** Users assigned to the group */
  assignedUserItems: Array<Maybe<User>>;
  /** Assigned users */
  assignedUsers: Scalars['Int']['output'];
  /** Group status */
  groupStatus: GroupStatus;
  id: Scalars['ID']['output'];
  /** Is general group */
  isGeneral: Scalars['Boolean']['output'];
  /** Is keycloak managed group */
  isKeycloak: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  /** Defines name of the group */
  name: LangString;
  /** Associated Role to a Group. */
  roles: Array<Maybe<Role>>;
  uuid: Scalars['UUID']['output'];
};

/** GraphQl mutation for updating and uspserting Groups */
export type GroupMutation = {
  __typename?: 'GroupMutation';
  bulkUpdateGroupStatus: Array<Maybe<Group>>;
  updateGroupStatus: Group;
  upsert: Group;
};


/** GraphQl mutation for updating and uspserting Groups */
export type GroupMutationBulkUpdateGroupStatusArgs = {
  input: BulkUpdateGroupStatusInput;
};


/** GraphQl mutation for updating and uspserting Groups */
export type GroupMutationUpdateGroupStatusArgs = {
  input: UpdateGroupStatusInput;
};


/** GraphQl mutation for updating and uspserting Groups */
export type GroupMutationUpsertArgs = {
  input: UpsertGroupInput;
};

/** A group */
export type GroupRefactored = {
  __typename?: 'GroupRefactored';
  /** Assigned media */
  assignedMedia: Scalars['Int']['output'];
  /** Assigned users */
  assignedUsers: Scalars['Int']['output'];
  /** Status */
  groupStatus: GroupStatus;
  /** Id */
  id: Scalars['Int']['output'];
  /** Is general group */
  isGeneral: Scalars['Boolean']['output'];
  /** Is keycloak created group */
  isKeycloak: Scalars['Boolean']['output'];
  /** Key */
  key: Scalars['String']['output'];
  /** Defines name of the group */
  name: LangString;
  /** Uuid */
  uuid: Scalars['UUID']['output'];
};

export enum GroupStatus {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED'
}

export type GroupsFiltersInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxMediaCount?: InputMaybe<Scalars['Int']['input']>;
  maxUsersCount?: InputMaybe<Scalars['Int']['input']>;
  minMediaCount?: InputMaybe<Scalars['Int']['input']>;
  minUsersCount?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HelpAdminInput = {
  gtcTextDe?: InputMaybe<Scalars['String']['input']>;
  gtcTextEn?: InputMaybe<Scalars['String']['input']>;
  gtcTextSw?: InputMaybe<Scalars['String']['input']>;
  imprintTextDe?: InputMaybe<Scalars['String']['input']>;
  imprintTextEn?: InputMaybe<Scalars['String']['input']>;
  imprintTextSw?: InputMaybe<Scalars['String']['input']>;
  introLink?: InputMaybe<Scalars['String']['input']>;
  introTextDe?: InputMaybe<Scalars['String']['input']>;
  introTextEn?: InputMaybe<Scalars['String']['input']>;
  introTextSw?: InputMaybe<Scalars['String']['input']>;
  privacyTextDe?: InputMaybe<Scalars['String']['input']>;
  privacyTextEn?: InputMaybe<Scalars['String']['input']>;
  privacyTextSw?: InputMaybe<Scalars['String']['input']>;
};

/** GraphQL mutation for updating and upserting HelpAdmin data */
export type HelpAdminMutation = {
  __typename?: 'HelpAdminMutation';
  seed?: Maybe<HelpAdmin_Output>;
  upsert: HelpAdmin_Output;
};


/** GraphQL mutation for updating and upserting HelpAdmin data */
export type HelpAdminMutationSeedArgs = {
  input: HelpAdminInput;
};


/** GraphQL mutation for updating and upserting HelpAdmin data */
export type HelpAdminMutationUpsertArgs = {
  input: HelpAdminInput;
};

/** Help Admin output object */
export type HelpAdmin_Output = {
  __typename?: 'HelpAdmin_output';
  /** Defines gtc */
  gtcText: Scalars['String']['output'];
  gtcTextDe?: Maybe<Scalars['String']['output']>;
  gtcTextEn?: Maybe<Scalars['String']['output']>;
  gtcTextSw?: Maybe<Scalars['String']['output']>;
  /** Defines imprint */
  imprintText: Scalars['String']['output'];
  imprintTextDe?: Maybe<Scalars['String']['output']>;
  imprintTextEn?: Maybe<Scalars['String']['output']>;
  imprintTextSw?: Maybe<Scalars['String']['output']>;
  introLink?: Maybe<Scalars['String']['output']>;
  /** Defines introduction of help */
  introText: Scalars['String']['output'];
  introTextDe?: Maybe<Scalars['String']['output']>;
  introTextEn?: Maybe<Scalars['String']['output']>;
  introTextSw?: Maybe<Scalars['String']['output']>;
  /** Defines privacy */
  privacyText: Scalars['String']['output'];
  privacyTextDe?: Maybe<Scalars['String']['output']>;
  privacyTextEn?: Maybe<Scalars['String']['output']>;
  privacyTextSw?: Maybe<Scalars['String']['output']>;
  systemLanguage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum HttpStatusCode {
  Accepted = 'ACCEPTED',
  AlreadyReported = 'ALREADY_REPORTED',
  Ambiguous = 'AMBIGUOUS',
  BadGateway = 'BAD_GATEWAY',
  BadRequest = 'BAD_REQUEST',
  Conflict = 'CONFLICT',
  Continue = 'CONTINUE',
  Created = 'CREATED',
  EarlyHints = 'EARLY_HINTS',
  ExpectationFailed = 'EXPECTATION_FAILED',
  FailedDependency = 'FAILED_DEPENDENCY',
  Forbidden = 'FORBIDDEN',
  GatewayTimeout = 'GATEWAY_TIMEOUT',
  Gone = 'GONE',
  HttpVersionNotSupported = 'HTTP_VERSION_NOT_SUPPORTED',
  ImUsed = 'IM_USED',
  InsufficientStorage = 'INSUFFICIENT_STORAGE',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  LengthRequired = 'LENGTH_REQUIRED',
  Locked = 'LOCKED',
  LoopDetected = 'LOOP_DETECTED',
  MethodNotAllowed = 'METHOD_NOT_ALLOWED',
  MisdirectedRequest = 'MISDIRECTED_REQUEST',
  Moved = 'MOVED',
  MultiStatus = 'MULTI_STATUS',
  NetworkAuthenticationRequired = 'NETWORK_AUTHENTICATION_REQUIRED',
  NonAuthoritativeInformation = 'NON_AUTHORITATIVE_INFORMATION',
  NotAcceptable = 'NOT_ACCEPTABLE',
  NotExtended = 'NOT_EXTENDED',
  NotFound = 'NOT_FOUND',
  NotImplemented = 'NOT_IMPLEMENTED',
  NotModified = 'NOT_MODIFIED',
  NoContent = 'NO_CONTENT',
  Ok = 'OK',
  PartialContent = 'PARTIAL_CONTENT',
  PaymentRequired = 'PAYMENT_REQUIRED',
  PermanentRedirect = 'PERMANENT_REDIRECT',
  PreconditionFailed = 'PRECONDITION_FAILED',
  PreconditionRequired = 'PRECONDITION_REQUIRED',
  Processing = 'PROCESSING',
  ProxyAuthenticationRequired = 'PROXY_AUTHENTICATION_REQUIRED',
  Redirect = 'REDIRECT',
  RedirectMethod = 'REDIRECT_METHOD',
  RequestedRangeNotSatisfiable = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  RequestEntityTooLarge = 'REQUEST_ENTITY_TOO_LARGE',
  RequestHeaderFieldsTooLarge = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  RequestTimeout = 'REQUEST_TIMEOUT',
  RequestUriTooLong = 'REQUEST_URI_TOO_LONG',
  ResetContent = 'RESET_CONTENT',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  SwitchingProtocols = 'SWITCHING_PROTOCOLS',
  TemporaryRedirect = 'TEMPORARY_REDIRECT',
  TooManyRequests = 'TOO_MANY_REQUESTS',
  Unauthorized = 'UNAUTHORIZED',
  UnavailableForLegalReasons = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  UnprocessableEntity = 'UNPROCESSABLE_ENTITY',
  UnsupportedMediaType = 'UNSUPPORTED_MEDIA_TYPE',
  Unused = 'UNUSED',
  UpgradeRequired = 'UPGRADE_REQUIRED',
  UseProxy = 'USE_PROXY',
  VariantAlsoNegotiates = 'VARIANT_ALSO_NEGOTIATES'
}

/** The Icon */
export type Icon = {
  __typename?: 'Icon';
  id: Scalars['ID']['output'];
  /** Image url */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Is Active */
  isActive: Scalars['Boolean']['output'];
  /** Is Default */
  isDefault: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  /** Title in German */
  titleDe?: Maybe<Scalars['String']['output']>;
  /** Title in English */
  titleEn?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

/** GraphQl mutation for updating/upsert icons */
export type IconMutation = {
  __typename?: 'IconMutation';
  upsertIcons?: Maybe<Icon>;
};


/** GraphQl mutation for updating/upsert icons */
export type IconMutationUpsertIconsArgs = {
  input: UpsertIconInput;
};

/** You can specify either a id, key or uuid, or let the system guess your value. Will be changed to `oneOf` type once it is in the GraphQL Spec */
export type IdOrKeyInput = {
  guess?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  /**
   * 
   * The key will be normalized to a valid key - it will be made uppercase, and non-letters will be 
   * converted to underscore. Consecutive, trailing and leading underscores will be ommitted.
   *             
   * Example: `john.doe@bitmedia.at` => `JOHN_DOE_BITMEDIA_AT`
   */
  laxKey?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['Uuid']['input']>;
};

export type ImportLogsFiltersInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  maxErrorsCount?: InputMaybe<Scalars['Int']['input']>;
  maxImportDate?: InputMaybe<Scalars['Instant']['input']>;
  maxImportedUsersCount?: InputMaybe<Scalars['Int']['input']>;
  minErrorsCount?: InputMaybe<Scalars['Int']['input']>;
  minImportDate?: InputMaybe<Scalars['Instant']['input']>;
  minImportedUsersCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ImportStatusEnum>;
};

export enum ImportStatusEnum {
  Error = 'ERROR',
  Fail = 'FAIL',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type ImportUserLogsInput = {
  errors: Scalars['Int']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  idOrKey: IdOrKeyInput;
  importedUsers: Scalars['Int']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  overwrite: Scalars['Boolean']['input'];
  overwritten?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Import users by uploading xlsx/csv file with user data */
export type ImportUsers = {
  __typename?: 'ImportUsers';
  /** Erros */
  errors: Scalars['Int']['output'];
  /** Filename */
  fileName: Scalars['String']['output'];
  /** File URL */
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Import date */
  importDate?: Maybe<Scalars['Instant']['output']>;
  key: Scalars['Key']['output'];
  /** Number of users */
  numberOfUsers: Scalars['Int']['output'];
  /** Status */
  status: ImportStatusEnum;
  uuid: Scalars['UUID']['output'];
};

/** Import users by uploading xlsx/csv file with user data */
export type ImportUsersRefactor = {
  __typename?: 'ImportUsersRefactor';
  /** Erros */
  errors: Scalars['Int']['output'];
  /** Filename */
  fileName: Scalars['String']['output'];
  /** File URL */
  fileUrl: Scalars['String']['output'];
  /** Import date */
  importDate: Scalars['String']['output'];
  /** Number of users */
  numberOfUsers: Scalars['Int']['output'];
  /** Status */
  status: ImportStatusEnum;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export enum IntervallTypeEnum {
  Annual = 'ANNUAL',
  Biannual = 'BIANNUAL',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Quaterly = 'QUATERLY',
  Weekly = 'WEEKLY'
}

export enum ItemType {
  Chapter = 'CHAPTER',
  Course = 'COURSE',
  Directupload = 'DIRECTUPLOAD',
  Event = 'EVENT',
  Link = 'LINK',
  Xeditor = 'XEDITOR'
}

export enum ItemUploadStatus {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Running = 'RUNNING'
}

/** Item upload status */
export type Item_Upload_Status = {
  __typename?: 'Item_Upload_Status';
  /** Show item upload status */
  itemIsDeleted: Scalars['Boolean']['output'];
  /** Actual status of process */
  itemStatus: ItemUploadStatus;
  /** Number of items to be uploaded in a process */
  itemTotalToUpload: Scalars['Int']['output'];
  /** How many items are uploaded from latest process */
  itemTotalUploaded: Scalars['Int']['output'];
};

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/**
 *
 * A localized or translatable text. To get the Neutral value (untranslated), a shortcut to 'neutral' is available.
 * To get the text that matches the current users preferences, use 'value'.
 *
 */
export type LangString = {
  __typename?: 'LangString';
  id: Scalars['ID']['output'];
  /** The neutral (untranslated) text that is used when no language specific override was found */
  neutral: Scalars['String']['output'];
  /** The localized text matching the users (or systems) preferences */
  value: Scalars['String']['output'];
  /** Localized values */
  values: Array<LangStringValue>;
};

export type LangStringValue = {
  __typename?: 'LangStringValue';
  id: Scalars['ID']['output'];
  /**
   *
   * The ISO 639 code.
   *
   * Example:
   * * de-AT
   * * en
   * * x-none
   *
   * :::note
   *
   * `x-none` is the default value
   *
   * :::
   *
   */
  locale: Scalars['String']['output'];
  /** The localized text */
  value: Scalars['String']['output'];
};

/** Latest catalogue */
export type LatestCatalogueWidget = {
  __typename?: 'LatestCatalogueWidget';
  /** Course uuid */
  courseUuid: Scalars['String']['output'];
  /** Create date */
  createDate?: Maybe<Scalars['String']['output']>;
  /** Course name */
  name: LangString;
};

export type LaunchScoResult = {
  __typename?: 'LaunchScoResult';
  attempt: Scorm12EnrolledItem;
  launchUri: Scalars['String']['output'];
  session: Scalars['UUID']['output'];
  sessionApiKey: Scalars['String']['output'];
};

export type LearningPathDetail = {
  __typename?: 'LearningPathDetail';
  chapter?: Maybe<LangString>;
  id?: Maybe<Scalars['Int']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  isReusable?: Maybe<Scalars['Boolean']['output']>;
  launchUri?: Maybe<Scalars['String']['output']>;
  lessonTitle?: Maybe<LangString>;
  mediaType: MediaType;
  mitType?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum LearningPathStatusEnum {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum LocalizationEnum {
  De = 'DE',
  En = 'EN'
}

/** The Mail Log */
export type MailLog = {
  __typename?: 'MailLog';
  createdDate?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  mailTemplate: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  userRecipient: User;
  userSenderUsername?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type MailLogFiltersInput = {
  status?: InputMaybe<Scalars['String']['input']>;
  userRecipient?: InputMaybe<Scalars['String']['input']>;
  userSender?: InputMaybe<Scalars['String']['input']>;
};

/** GraphQL mutation for updating and upserting Mail Templates */
export type MailTemplatesMutation = {
  __typename?: 'MailTemplatesMutation';
  seed: Mailtemplate;
  upsert: Mailtemplate;
};


/** GraphQL mutation for updating and upserting Mail Templates */
export type MailTemplatesMutationSeedArgs = {
  input: UpsertMailTemplateInput;
};


/** GraphQL mutation for updating and upserting Mail Templates */
export type MailTemplatesMutationUpsertArgs = {
  input: UpsertMailTemplateInput;
};

/** A mail template */
export type Mailtemplate = {
  __typename?: 'Mailtemplate';
  /** German additional information */
  additionalInformationDe?: Maybe<Scalars['String']['output']>;
  /** English additional information */
  additionalInformationEn?: Maybe<Scalars['String']['output']>;
  /** Swahili additional information */
  additionalInformationSw?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  /** German main text */
  mainTextDe?: Maybe<Scalars['String']['output']>;
  /** English main text */
  mainTextEn?: Maybe<Scalars['String']['output']>;
  /** Swahili main text */
  mainTextSw?: Maybe<Scalars['String']['output']>;
  /** Metadata */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Defines name of the mail template */
  name: LangString;
  /** Defines name of the mail template */
  name2: Scalars['String']['output'];
  /** German subject */
  subjectDe?: Maybe<Scalars['String']['output']>;
  /** English subject */
  subjectEn?: Maybe<Scalars['String']['output']>;
  /** Swahili subject */
  subjectSw?: Maybe<Scalars['String']['output']>;
  systemLanguage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Type */
  type: EmailTemplateEnum;
  uuid: Scalars['UUID']['output'];
};

/** Detailed statistics of a media */
export type MediaDetailsStatisticsGql = {
  __typename?: 'MediaDetailsStatisticsGQL';
  /** Automatic assignment: unit of accessAfterValue */
  accessAfterUnit?: Maybe<RelativeTimeUnitEnum>;
  /** Automatic assignment: delay before access is granted. Null or 0 means immediately */
  accessAfterValue?: Maybe<Scalars['Int']['output']>;
  /** Automatic assignment: unit of accessDurationValue */
  accessDurationUnit?: Maybe<RelativeTimeUnitEnum>;
  /** Automatic assignment: how long access lasts once granted. Null means no end date */
  accessDurationValue?: Maybe<Scalars['Int']['output']>;
  /** Active */
  active: Scalars['String']['output'];
  /** User Active Lessons */
  activeLessons?: Maybe<Array<Maybe<UserStaticsLesson>>>;
  /** Are courses notifications on */
  areNotificationsOn: Scalars['Boolean']['output'];
  /** How the access window is defined: STANDARD = absolute start/end date shared by the group, AUTOMATIC = a window computed per learner from when they joined */
  assignmentType: AssignmentTypeEnum;
  /** Calls */
  calls: Scalars['Int']['output'];
  /** Catalog booked */
  catalog: Scalars['Boolean']['output'];
  /** Completion date */
  completion?: Maybe<Scalars['Instant']['output']>;
  /** Is completion notification on */
  completionNotification: Scalars['Boolean']['output'];
  /** Contact notified */
  contactNotified?: Maybe<Array<Maybe<Role>>>;
  /** Contact roles */
  contactRoles: Scalars['String']['output'];
  /** Course title */
  courseTitle: LangString;
  /** Uuid */
  courseUuid: Scalars['String']['output'];
  /** Current result */
  currentResult: Scalars['Float']['output'];
  /** Date of reminder */
  dateOfReminder: Scalars['Int']['output'];
  /** Email of the user */
  email: Scalars['String']['output'];
  /** End date */
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Enrollment date */
  enrollment?: Maybe<Scalars['Instant']['output']>;
  /** Firstname of the user */
  firstName: Scalars['String']['output'];
  /** Group assigned */
  group?: Maybe<Group>;
  /** Enroll history calls */
  historyCalls: Scalars['Int']['output'];
  /** Enroll history status */
  historyStatus?: Maybe<Scalars['String']['output']>;
  /** Course id */
  id: Scalars['String']['output'];
  /** Intervall */
  intervall: Scalars['String']['output'];
  /** Intervall End date */
  intervallEndDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Is group media active */
  isActive: Scalars['Boolean']['output'];
  /** Is user anonymized */
  isAnonymized: Scalars['Boolean']['output'];
  /** Lastname of the user */
  lastName: Scalars['String']['output'];
  /** Assigned learners */
  learners?: Maybe<Array<Maybe<User>>>;
  /** Is new course notification on */
  newCourseNotification: Scalars['Boolean']['output'];
  /** Start date */
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Status */
  status: Scalars['String']['output'];
  /** Type */
  type: Scalars['String']['output'];
  /** Group assigned */
  unit?: Maybe<Unit>;
  /** Uuid */
  uuid: Scalars['String']['output'];
};

export type MediaFiltersInput = {
  groups?: InputMaybe<Scalars['String']['input']>;
  hasCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveForCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  maxTopics?: InputMaybe<Scalars['Int']['input']>;
  minGroups?: InputMaybe<Scalars['Int']['input']>;
  minTopics?: InputMaybe<Scalars['Int']['input']>;
  selectedCategory?: InputMaybe<Scalars['UUID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A course */
export type MediaGqlRefactored = {
  __typename?: 'MediaGQLRefactored';
  /** Active for catalog */
  activeForCatalog: Scalars['Boolean']['output'];
  /** Assigned categories */
  assignedCategories: Scalars['Int']['output'];
  /** Assigned categories */
  assignedCategoriesIds: Array<Scalars['UUID']['output']>;
  /** Assigned groups */
  assignedGroups: Scalars['Int']['output'];
  /** Who may see the course in the catalog: ALL_USERS or GROUPS. Only meaningful while activeForCatalog is true. */
  catalogAudience: CatalogAudienceEnum;
  /** Uuids of the groups the course is offered to when catalogAudience is GROUPS. */
  catalogGroupUuids?: Maybe<Array<Scalars['UUID']['output']>>;
  /** Certificate */
  certificate: Scalars['Boolean']['output'];
  creator?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['String']['output'];
  /** Catalog */
  isActive: Scalars['Boolean']['output'];
  /** Is user allowed to edit course */
  isAllowedToEdit: Scalars['Boolean']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isLearningPath?: Maybe<Scalars['Boolean']['output']>;
  /** Course item identifier */
  itemIdentifier: Scalars['String']['output'];
  /** Language */
  language: Scalars['String']['output'];
  /** Media type */
  mediaType: MediaType;
  scos?: Maybe<Array<Maybe<LearningPathDetail>>>;
  /** Defines name of the course */
  title: LangString;
  /** Type */
  type: Scalars['String']['output'];
  /** Uuid */
  uuid: Scalars['UUID']['output'];
  /** Current version */
  version: Scalars['String']['output'];
};

/** Learner statistics of a media */
export type MediaLearnerStatisticsGql = {
  __typename?: 'MediaLearnerStatisticsGQL';
  /** Activations of the course, one per group assignment or catalog booking */
  activations: Array<Maybe<MediaDetailsStatisticsGql>>;
  /** Calls */
  calls: Scalars['Int']['output'];
  /** Completion date of the current activation */
  completion?: Maybe<Scalars['Instant']['output']>;
  /** Current result */
  currentResult: Scalars['Float']['output'];
  /** Email of the user */
  email: Scalars['String']['output'];
  /** Firstname of the user */
  firstName: Scalars['String']['output'];
  /** Groups the course is assigned through */
  groups: Array<Maybe<Group>>;
  /** Is user anonymized */
  isAnonymized: Scalars['Boolean']['output'];
  /** Lastname of the user */
  lastName: Scalars['String']['output'];
  /** Mandatory in at least one group */
  mandatory: Scalars['Boolean']['output'];
  /** Recurring in at least one group */
  recurring: Scalars['Boolean']['output'];
  /** Status of the current activation */
  status: Scalars['String']['output'];
  /** Uuid of the user */
  uuid: Scalars['String']['output'];
};

export type MediaStatisticsFiltersInput = {
  creationDateMax?: InputMaybe<Scalars['Instant']['input']>;
  creationDateMin?: InputMaybe<Scalars['Instant']['input']>;
  groups?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCourseCallDateMax?: InputMaybe<Scalars['Instant']['input']>;
  lastCourseCallDateMin?: InputMaybe<Scalars['Instant']['input']>;
  maxAssignmentsCount?: InputMaybe<Scalars['Int']['input']>;
  maxCallsCount?: InputMaybe<Scalars['Int']['input']>;
  maxCompletionsCount?: InputMaybe<Scalars['Int']['input']>;
  minAssignmentsCount?: InputMaybe<Scalars['Int']['input']>;
  minCallsCount?: InputMaybe<Scalars['Int']['input']>;
  minCompletionsCount?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Statistics of a Media */
export type MediaStatisticsOverview = {
  __typename?: 'MediaStatisticsOverview';
  /** Number of assigned learners (a learner assigned through several groups counts once) */
  assignedLearners: Scalars['Int']['output'];
  /** Number of completions */
  assignedLearnersDetails: Array<Maybe<MediaDetailsStatisticsGql>>;
  /** Course title */
  courseTitle: LangString;
  /** Course id */
  createdDate: Scalars['String']['output'];
  /** Course id */
  id: Scalars['String']['output'];
  /** Item Identifier */
  itemIdentifier: Scalars['String']['output'];
  /** Last course call */
  lastCourseCall: Scalars['String']['output'];
  /** Assigned learners, one entry per learner with their activations */
  learnerStatistics: Array<Maybe<MediaLearnerStatisticsGql>>;
  /** Number of calls */
  numberOfCalls: Scalars['Int']['output'];
  /** Number of learners who completed the course */
  numberOfCompletions: Scalars['Int']['output'];
  /** UUID */
  uuid: Scalars['UUID']['output'];
};

export enum MediaType {
  Chapter = 'CHAPTER',
  Document = 'DOCUMENT',
  Event = 'EVENT',
  ELearning = 'E_LEARNING',
  LearningPath = 'LEARNING_PATH',
  Link = 'LINK',
  Lti = 'LTI',
  Task = 'TASK',
  Video = 'VIDEO'
}

export type MembersDto = {
  __typename?: 'MembersDto';
  completed: Scalars['Boolean']['output'];
  completedDate?: Maybe<Scalars['Instant']['output']>;
  file?: Maybe<AttachmentInfo>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

/** GraphQL mutation to update, upsert, remove menu */
export type MenuMutation = {
  __typename?: 'MenuMutation';
  remove: Scalars['Boolean']['output'];
  upsert: Scalars['String']['output'];
};


/** GraphQL mutation to update, upsert, remove menu */
export type MenuMutationRemoveArgs = {
  idOrKey: Scalars['String']['input'];
};


/** GraphQL mutation to update, upsert, remove menu */
export type MenuMutationUpsertArgs = {
  input: UpsertLauncherInput;
};

export type Menu_Configuration = {
  __typename?: 'Menu_Configuration';
  /** Additional configuration for the launcher in JSON format. */
  additionalConfiguration: Scalars['String']['output'];
  /** The alignment of the launcher (e.g., PRIMARY, SECONDARY). */
  alignment: Scalars['String']['output'];
  /** The base URL for the launcher. */
  baseUrl: Scalars['String']['output'];
  /** CSS classes applied to the launcher. */
  cssClasses: Scalars['String']['output'];
  /** The auncher HideForRoles. */
  hideForRoles: Array<Maybe<Scalars['String']['output']>>;
  /** The unique identifier of the launcher */
  id: Scalars['String']['output'];
  /** The image URL or path for the launcher. */
  image: Scalars['String']['output'];
  /** Indicates whether the launcher is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /** The unique key of the launcher */
  key: Scalars['String']['output'];
  /** The localized label of the launcher. */
  label: Scalars['String']['output'];
  /** The Neutral label of the launcher. */
  labelNeutral: Scalars['String']['output'];
  /** The order of the launcher in the menu. */
  order: Scalars['Int']['output'];
  /** The path for the launcher. */
  path: Scalars['String']['output'];
  /** The launcher ShowForRoles. */
  showForRoles: Array<Maybe<Scalars['String']['output']>>;
  /** The type of the launcher (e.g., IFRAME, WINDOW). */
  type: Scalars['String']['output'];
  /** The UUID of the launcher. */
  uuid: Scalars['String']['output'];
};

export type ModulePreference = {
  __typename?: 'ModulePreference';
  createdAt: Scalars['Instant']['output'];
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  moduleName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Module_Preference = {
  __typename?: 'Module_preference';
  /** Defines preference key */
  key: Scalars['String']['output'];
  /** Defines module name */
  moduleName: Scalars['String']['output'];
  /** Defines preference value */
  value: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** GraphQL mutation for creating/upserting tokens */
  authorizationToken: AuthorizationTokenMutation;
  /** GraphQL mutation for managing badges */
  badgeMutationGql?: Maybe<BadgesMutation>;
  /** GraphQL mutation for managing badges notifications */
  badgeNotificationsMutationGql?: Maybe<BadgeNotificationsMutation>;
  /** GraphQL mutation for managing Catalog favorites. */
  catalagoueFavouriteMutation?: Maybe<CatalogueFavouriteMutation>;
  /** GraphQL mutation for managing Categories/Topics */
  category?: Maybe<CategoryMutation>;
  /** GraphQL mutation for managing Certificates */
  certificateMutation?: Maybe<CertificatesMutation>;
  /** GraphQL mutation for managing Configurations */
  configsMutation?: Maybe<ConfigsMutation>;
  /** GraphQL mutation for managing CourseEvaluation */
  courseEvaluationMutation?: Maybe<CourseEvaluationMutation>;
  /** GraphQL mutation for managing favorite courses. */
  courseFavourite?: Maybe<CourseFavouriteMutation>;
  /** GraphQL mutation for managing Groups. */
  groupMutation?: Maybe<GroupMutation>;
  /** GraphQL mutation for managing HelpAdmin data */
  helpAdminMutation?: Maybe<HelpAdminMutation>;
  /** GraphQL mutation for managing icons */
  iconMutationGql?: Maybe<IconMutation>;
  /** GraphQL mutation for managing MailTemplates */
  mailTemplatesMutation?: Maybe<MailTemplatesMutation>;
  /** GraphQL mutation for managing menu */
  menuMutation?: Maybe<MenuMutation>;
  /** Generate fresh UUIDs */
  newUUID: Array<Scalars['UUID']['output']>;
  /** GraphQL mutation for News */
  news?: Maybe<NewsMutationGql>;
  /** GraphQL mutation for managing nuggets */
  nuggetMutationGql?: Maybe<NuggetMutation>;
  /** GraphQL mutation for managing relatives */
  parentMutationGql?: Maybe<ParentMutationGql>;
  /** GraphQL mutation for preferences */
  preferencesMutation?: Maybe<PreferencesMutation>;
  /** GraphQL mutation for managing Roles */
  roleMutation?: Maybe<RoleMutationGql>;
  /** GraphQL mutation for managing Scorm attempts */
  scorm12Attempt: Scorm12AttemptMutation;
  /** GraphQL mutation for managing Scorm Courses */
  scorm12Course: Scorm12CourseMutation;
  /** GraphQL mutation for managing enrolled scorm Courses */
  scorm12EnrolledCourse: EnrolledCourseMutation;
  /** GraphQL mutation for managing ScormItems */
  scorm12Item: Scorm12ItemMutation;
  /** GraphQL mutation for managing SelfRegistration */
  selfRegistrationMutation?: Maybe<SelfRegistrationMutationGql>;
  /** Mutation for setting the LTI proxy URL in JobManager realm metadata */
  setLtiProxyUrl: Scalars['Boolean']['output'];
  /** Query for setting systems Primary Color */
  setPrimaryColor: Scalars['Boolean']['output'];
  /** Mutation for setting proxy body size in JobManager metadata */
  setProxyBodySize: Scalars['Boolean']['output'];
  /** Mutation for setting the X-Editor URL in JobManager realm metadata */
  setXEditorUrl: Scalars['Boolean']['output'];
  /** GraphQL mutation for managing Units. */
  unitMutation?: Maybe<UnitMutation>;
  /** GraphQL mutation for managing Users */
  user: UserMutation;
  /** GraphQL mutation for UserNews */
  userNews?: Maybe<UserNewsMutationGql>;
  /** GraphQL mutation for managing Widgets */
  widget: WidgetMutation;
  /** GraphQL mutation for managing zulip chat */
  zulipChatMutation?: Maybe<ZulipChatMutation>;
};


export type MutationNewUuidArgs = {
  count: Scalars['Int']['input'];
};


export type MutationSetLtiProxyUrlArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetPrimaryColorArgs = {
  primaryColor?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetProxyBodySizeArgs = {
  limit: Scalars['Int']['input'];
};


export type MutationSetXEditorUrlArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A certificate */
export type MyCertificates = {
  __typename?: 'MyCertificates';
  /** Enrolled course completion date */
  completionDate: Scalars['String']['output'];
  /** Certificate present in course */
  courseHasCertificate: Scalars['Boolean']['output'];
  /** Course uuid */
  courseUuid: Scalars['String']['output'];
  /** Enrolled course uuid */
  enrolledCourseUuid: Scalars['String']['output'];
  /** Course name */
  name: LangString;
  /** User uuid */
  userUuid: Scalars['String']['output'];
};

export type News = {
  __typename?: 'News';
  audience: NewsAudienceEnum;
  author: User;
  creationDate: Scalars['Instant']['output'];
  groups: Array<Maybe<Group>>;
  id: Scalars['ID']['output'];
  isImportant: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  message: LangString;
  publishedDate?: Maybe<Scalars['Instant']['output']>;
  recipients: Scalars['Int']['output'];
  sendToRelative: Scalars['Boolean']['output'];
  sentGroupName: LangString;
  title: LangString;
  userNewsUuid?: Maybe<Scalars['String']['output']>;
  users: Array<Maybe<User>>;
  uuid: Scalars['UUID']['output'];
};

export enum NewsAudienceEnum {
  Group = 'GROUP',
  User = 'USER'
}

export type NewsConnectionGql = {
  __typename?: 'NewsConnectionGQL';
  edges: Array<NewsEdgeGql>;
  nodes: Array<News>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NewsEdgeGql = {
  __typename?: 'NewsEdgeGQL';
  cursor: Scalars['String']['output'];
  node: News;
};

export type NewsFiltersInput = {
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  recipients?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsMutationGql = {
  __typename?: 'NewsMutationGQL';
  activateNews: Scalars['Boolean']['output'];
  deactivateNews: Scalars['Boolean']['output'];
  deleteRange: Scalars['Boolean']['output'];
  upsert: News;
};


export type NewsMutationGqlActivateNewsArgs = {
  input: Array<InputMaybe<IdOrKeyInput>>;
};


export type NewsMutationGqlDeactivateNewsArgs = {
  input: Array<InputMaybe<IdOrKeyInput>>;
};


export type NewsMutationGqlDeleteRangeArgs = {
  input: Array<InputMaybe<IdOrKeyInput>>;
};


export type NewsMutationGqlUpsertArgs = {
  input: NewsUpsertInput;
};

export type NewsUpsertInput = {
  audience: NewsAudienceEnum;
  groups?: InputMaybe<Array<Scalars['UUID']['input']>>;
  idOrKey: IdOrKeyInput;
  isImportant: Scalars['Boolean']['input'];
  isPublished: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  message?: InputMaybe<UpsertLangStringInput>;
  sendToRelative: Scalars['Boolean']['input'];
  title?: InputMaybe<UpsertLangStringInput>;
  users?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** GraphQL mutation to upsert nugget */
export type NuggetMutation = {
  __typename?: 'NuggetMutation';
  archiveAndCompleteTask: Scalars['String']['output'];
  bulkDeleteScorm12Item: Array<Maybe<Scorm12Item>>;
  deleteItemUploadStatus: Item_Upload_Status;
  deleteTaskUploads: Scalars['Boolean']['output'];
  dragAndDrop?: Maybe<Scorm12Item>;
  expandChapter?: Maybe<Scorm12Item>;
  resetTask: Scalars['Boolean']['output'];
  uploadItemsJob: Scalars['Boolean']['output'];
  upsertChapter?: Maybe<Scorm12Item>;
  upsertUploadNugget?: Maybe<Scorm12Item>;
};


/** GraphQL mutation to upsert nugget */
export type NuggetMutationArchiveAndCompleteTaskArgs = {
  input: TaskInput;
};


/** GraphQL mutation to upsert nugget */
export type NuggetMutationBulkDeleteScorm12ItemArgs = {
  input: BulkDeleteScorm12ItemInput;
};


/** GraphQL mutation to upsert nugget */
export type NuggetMutationDeleteTaskUploadsArgs = {
  input: UpsertRef2Input;
};


/** GraphQL mutation to upsert nugget */
export type NuggetMutationDragAndDropArgs = {
  inputs?: InputMaybe<DragAndDropInputsInput>;
};


/** GraphQL mutation to upsert nugget */
export type NuggetMutationExpandChapterArgs = {
  chapterUuid: Scalars['UUID']['input'];
};


/** GraphQL mutation to upsert nugget */
export type NuggetMutationResetTaskArgs = {
  input: TaskInput;
};


/** GraphQL mutation to upsert nugget */
export type NuggetMutationUploadItemsJobArgs = {
  inputs?: InputMaybe<BulkInsertReuseNuggetInput>;
};


/** GraphQL mutation to upsert nugget */
export type NuggetMutationUpsertChapterArgs = {
  input: UpsertNuggetInputsInput;
};


/** GraphQL mutation to upsert nugget */
export type NuggetMutationUpsertUploadNuggetArgs = {
  inputs: UpsertNuggetInputsInput;
};

export type Page = {
  __typename?: 'Page';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedResultOfCategoryRefactor = {
  __typename?: 'PaginatedResultOfCategoryRefactor';
  data?: Maybe<Array<Maybe<CategoryRefactor>>>;
  page?: Maybe<Page>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResultOfGroupRefactored = {
  __typename?: 'PaginatedResultOfGroupRefactored';
  data?: Maybe<Array<Maybe<GroupRefactored>>>;
  page?: Maybe<Page>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResultOfImportUsersRefactor = {
  __typename?: 'PaginatedResultOfImportUsersRefactor';
  data?: Maybe<Array<Maybe<ImportUsersRefactor>>>;
  page?: Maybe<Page>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResultOfMailLog = {
  __typename?: 'PaginatedResultOfMailLog';
  data?: Maybe<Array<Maybe<MailLog>>>;
  page?: Maybe<Page>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResultOfMediaDetailsStatisticsGql = {
  __typename?: 'PaginatedResultOfMediaDetailsStatisticsGQL';
  data?: Maybe<Array<Maybe<MediaDetailsStatisticsGql>>>;
  page?: Maybe<Page>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResultOfMediaGqlRefactored = {
  __typename?: 'PaginatedResultOfMediaGQLRefactored';
  data?: Maybe<Array<Maybe<MediaGqlRefactored>>>;
  page?: Maybe<Page>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResultOfScorm12Course = {
  __typename?: 'PaginatedResultOfSCORM12Course';
  data?: Maybe<Array<Maybe<Scorm12Course>>>;
  page?: Maybe<Page>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResultOfScorm12EnrolledCourseDto = {
  __typename?: 'PaginatedResultOfScorm12EnrolledCourseDto';
  data?: Maybe<Array<Maybe<Scorm12EnrolledCourseDto>>>;
  page?: Maybe<Page>;
  totalCount: Scalars['Int']['output'];
};

export type ParentConnectionGql = {
  __typename?: 'ParentConnectionGQL';
  edges: Array<ParentEdgeGql>;
  nodes: Array<ParentGql>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ParentEdgeGql = {
  __typename?: 'ParentEdgeGQL';
  cursor: Scalars['String']['output'];
  node: ParentGql;
};

export type ParentGql = {
  __typename?: 'ParentGQL';
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relatives?: Maybe<Array<Maybe<ParentGql>>>;
  uuid: Scalars['UUID']['output'];
};

export type ParentMutationGql = {
  __typename?: 'ParentMutationGQL';
  deleteParent: ResponseWrapperOfBoolean;
};


export type ParentMutationGqlDeleteParentArgs = {
  input?: InputMaybe<Array<InputMaybe<IdOrKeyInput>>>;
};

export type ParentsFilterInput = {
  relativeName?: InputMaybe<Scalars['String']['input']>;
  studentName?: InputMaybe<Scalars['String']['input']>;
};

export type PersonAssignmnetTokenDto = {
  __typename?: 'PersonAssignmnetTokenDTO';
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** A position */
export type Position = {
  __typename?: 'Position';
  /** Defines cols of the position */
  cols: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  /** Defines rows of the position */
  rows: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
  /** Defines x of the position */
  x: Scalars['Int']['output'];
  /** Defines y of the position */
  y: Scalars['Int']['output'];
};

export type PositionInput = {
  cols: Scalars['Int']['input'];
  rows: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

/** A course object used before the course is uploaded */
export type PreConfirmScorm12CourseGql = {
  __typename?: 'PreConfirmScorm12CourseGQL';
  /** All badges */
  allBadges: Array<Maybe<Badges>>;
  /** All categories */
  allCategories: Array<Maybe<Category>>;
  /** All certificates */
  allCertificates: Array<Maybe<Certificate>>;
  /** All groups */
  allGroups: Array<Maybe<Group>>;
  /** Assigned category names concatenated with comma */
  assignedCategories?: Maybe<Scalars['String']['output']>;
  /** Assigned categories count */
  assignedCategoriesCount: Scalars['Int']['output'];
  /** Assigned groups count */
  assignedGroupsCount: Scalars['Int']['output'];
  /** Assigned learners */
  assignedLearners?: Maybe<Array<Maybe<MediaDetailsStatisticsGql>>>;
  /** Who may see the course in the catalog: ALL_USERS or GROUPS. Only meaningful while showInCatalog is true. */
  catalogAudience: CatalogAudienceEnum;
  /** Uuids of the groups the course is offered to when catalogAudience is GROUPS. */
  catalogGroupUuids?: Maybe<Array<Scalars['UUID']['output']>>;
  /** Categories assigned to the course */
  categories: Array<Maybe<Category>>;
  /** Categories not assigned to the course */
  categoriesNotAssigned: Array<Maybe<Category>>;
  /** Count of chapters */
  chaptersCount: Scalars['Int']['output'];
  /** Course evaluation */
  courseEvaluations: Array<Maybe<CourseEvaluationGql>>;
  courseMediaURL?: Maybe<Scalars['String']['output']>;
  /** Defines uuid of the course */
  courseUuid: Scalars['String']['output'];
  /** Returns full name of the creator */
  createdBy: Scalars['String']['output'];
  /** Date when Course was created. */
  createdDate: Scalars['Instant']['output'];
  /** Dashboard Mode */
  dashboardMode: DashboardMode;
  /** Defines description of the course */
  description: LangString;
  /** Enable Badge */
  enableBadge?: Maybe<CourseUploadAccessibility>;
  /** Enable Dashboard Mode */
  enableDashboardMode: Scalars['Boolean']['output'];
  /** Course enrolled details */
  enrolledDetails?: Maybe<MediaDetailsStatisticsGql>;
  enrollment?: Maybe<Scorm12EnrolledCourse>;
  /** Date when Course is expired. */
  expirationDate?: Maybe<Scalars['Instant']['output']>;
  /** External launch URL (populated for LTI courses; null otherwise). */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Groups assigned to the course */
  groups: Array<Maybe<Group>>;
  /** Groups not assigned to the course */
  groupsNotAssigned: Array<Maybe<Group>>;
  /** Check if there is a draft version for the course */
  hasDraft?: Maybe<Scalars['Boolean']['output']>;
  /** HistoryData */
  historyData: Array<Maybe<CourseVersionGql>>;
  id: Scalars['ID']['output'];
  /**
   * Image
   * @deprecated Use imageUrl
   */
  image?: Maybe<Scalars['String']['output']>;
  /**
   * Image Type
   * @deprecated Use imageUrl
   */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Cacheable, public tile image URL. Null when the course has no image. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Defines if the course is active */
  isActive: Scalars['Boolean']['output'];
  /** Defines if user allowed to edit course */
  isAllowedToEdit: Scalars['Boolean']['output'];
  /** Defines if the course is booked */
  isBooked: Scalars['Boolean']['output'];
  /** Defines if the course is booked from Catalog */
  isCatalog: Scalars['Boolean']['output'];
  /** Check if zulip chat is enabled for the course */
  isChatEnabled: Scalars['Boolean']['output'];
  /** Defines if the course is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Defines if user allowed to edit course */
  isEditableByOthers: Scalars['Boolean']['output'];
  /** Defines if the course is favourite for the logged in user */
  isFavourite: Scalars['Boolean']['output'];
  /** Check if the course is a learning path */
  isLearningPath: Scalars['Boolean']['output'];
  /** Defines if user allowed to change editable value */
  isOwnerOrAdmin: Scalars['Boolean']['output'];
  /** Defines if the course is published */
  isPublished: Scalars['Boolean']['output'];
  /** Is task completed or started */
  isTaskCompletedOrStarted: Scalars['Boolean']['output'];
  /** Course item identifier */
  itemIdentifier: Scalars['String']['output'];
  items?: Maybe<Array<Maybe<Scorm12Item>>>;
  key: Scalars['Key']['output'];
  /** Language */
  language: Scalars['String']['output'];
  /** Last publish date */
  lastPublishDate?: Maybe<Scalars['Instant']['output']>;
  /** Count of chapters */
  learningPathChaptersCount: Scalars['Int']['output'];
  /** Count of lessons */
  learningPathLessonsCount: Scalars['Int']['output'];
  /** Calls the SCOs of the course */
  learningPathScos: Array<Maybe<Scorm12Item>>;
  /** Count of lessons */
  lessonsCount: Scalars['Int']['output'];
  /** Media type */
  mediaType: MediaType;
  /** MIT Custom Tag */
  mit?: Maybe<Scalars['String']['output']>;
  /** Defines name of the course */
  name: LangString;
  /** Overall rating averaged from active evaluations, rounded to nearest 0.5 */
  overallRating?: Maybe<Scalars['Float']['output']>;
  /** Calls the SCOs of the course */
  scos: Array<Maybe<Scorm12Item>>;
  /** Selected Badge */
  selectedBadge?: Maybe<Badges>;
  /** Selected certificate */
  selectedCertificate?: Maybe<Certificate>;
  /** Defines if the course is shown in catalog */
  showInCatalog: Scalars['Boolean']['output'];
  /** Total learning time */
  totalLearningTime?: Maybe<Scalars['Duration']['output']>;
  /** Count of items that have a launch uri (are trackable) */
  trackableItems: Scalars['Int']['output'];
  /** Typical Learning Time (when set) */
  typicalLearningTime?: Maybe<Scalars['Duration']['output']>;
  /** Date when Course was last updated. */
  updatedDate: Scalars['Instant']['output'];
  uuid: Scalars['UUID']['output'];
  /** Current Version */
  version?: Maybe<Scalars['String']['output']>;
  /** Video Or Pdf Content */
  videoOrPdfContent?: Maybe<FileInfoResult>;
};

export type PreferenceInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Mutation for preferences */
export type PreferencesMutation = {
  __typename?: 'PreferencesMutation';
  addNewPreference: ModulePreference;
  addOrUpdatePreference: Array<Maybe<ModulePreference>>;
};


/** Mutation for preferences */
export type PreferencesMutationAddNewPreferenceArgs = {
  input: PreferenceInput;
};


/** Mutation for preferences */
export type PreferencesMutationAddOrUpdatePreferenceArgs = {
  inputs: Array<InputMaybe<PreferenceInput>>;
};

/** The rules that can make a role. Users get the privileges of each rule of each role */
export type Privilege = {
  __typename?: 'Privilege';
  /** The description of the rule */
  description: LangString;
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  /** The (short) name of the rule */
  name: LangString;
  uuid: Scalars['UUID']['output'];
};

export enum ProfileSortingItems {
  Date = 'DATE',
  Role = 'ROLE',
  Title = 'TITLE'
}

export type PromoteUserInput = {
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  unitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PublishLearningPathInput = {
  courseUuid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<UpsertLangStringInput>;
  title?: InputMaybe<UpsertLangStringInput>;
};

export enum PublishStatus {
  Enrollable = 'ENROLLABLE',
  Invisible = 'INVISIBLE'
}

export type Query = {
  __typename?: 'Query';
  /** GraphQL query type for retrieving Assistant data */
  assistant?: Maybe<QueryAssistant>;
  /** GraphQL query for Attempts, which includes methods to query and retrieve data from a database */
  attempts: QueryScorm12Attempts;
  /** GraqhQL query type for retrieving Badges data */
  badge?: Maybe<QueryBadgesGql>;
  /** GraqhQL query type for retrieving Badges data */
  badgeNotifications?: Maybe<QueryBadgeNotificationsGql>;
  /** GraphQL queries for retrieving and updating categories/topics in the application */
  categories: QueryCategoriesGql;
  /** GraphQL queries related to certificates in the application, including fetching all certificates and generating certificate previews */
  certificates?: Maybe<QueryCertificatesGql>;
  /** GraphQL query type for retrieving a single instance of ConfigGQL */
  configs?: Maybe<QueryConfigGql>;
  /** GraphQL queries for dashboard statistics across different areas of the application */
  dashboardStatistics: QueryDashboardStatistics;
  /** GraqhQL query type for retrieving evaluation data */
  evaluations?: Maybe<QueryEvaluationsGql>;
  /** GraphQL query type for retrieving Events */
  events?: Maybe<QueryEventsGql>;
  /** GraphQL query type for retrieving Groups */
  groups?: Maybe<QueryGroupsGql>;
  /** GraphQL query class for HelpAdmin entities, providing operations for retrieving and removing HelpAdmin data. */
  helpAdmin?: Maybe<QueryHelpAdminGql>;
  /** GraqhQL query type for retrieving icon data */
  icon?: Maybe<QueryIconGql>;
  /** Query for getting the configured LTI proxy URL. Returns an empty string when not configured. */
  ltiProxyUrl: Scalars['String']['output'];
  /** GraqhQL query type for retrieving mail log data */
  mailLog?: Maybe<QueryMailLog>;
  /** GraphQL query class for retrieving and filtering MailTemplate data from the database, including getting all MailTemplate data and getting MailTemplate data by ID. */
  mailTemplates?: Maybe<QueryEmailTemplatesGql>;
  /** GraphQL queries for media, including retrieving paginated results and updating enrolled courses' active status. */
  media?: Maybe<QueryMediaGql>;
  /** GraqhQL query type for retrieving module preference data */
  menuConfiguration?: Maybe<QueryMenuConfigurationGql>;
  /** GraqhQL query type for retrieving module preference data */
  modulePreferences?: Maybe<QueryModulePreferenceGql>;
  /** GraphQL query for news */
  news?: Maybe<QueryNews>;
  /** GraqhQL query type for retrieving nugget data */
  nugget?: Maybe<QueryNuggetGql>;
  /** GraqhQL query type for retrieving relatives data */
  parent?: Maybe<QueryParentGql>;
  /** Query for getting systems Primary Color */
  primaryColor: Scalars['String']['output'];
  /** GraqhQL query type for retrieving zulip chat  data */
  queryZulip?: Maybe<QueryZulip>;
  /**  GraphQL query class for querying and retrieving roles, implementing a connection and edge class for pagination and returning a single role or list of roles based on specified arguments. */
  roles?: Maybe<QueryRoles>;
  /** GraphQL query type for retrieving course accessibility status */
  scorm12CourseUploadAccessibility?: Maybe<QueryUploadAccessibilityGql>;
  /** GraphQl queries for retriving and exporting Scorm Courses, courses for the catalogue and media statistics */
  scorm12Courses: QueryScorm12Courses;
  /** GraphQL query for Scorm12EnrolledCourses, which includes methods to query and retrieve data from a database */
  scorm12EnrolledCourses: QueryScorm12EnrolledCourses;
  /** GraphQL query for Scorm12Items, which includes methods to query and retrieve data from a database */
  scorm12Items: QueryScorm12ItemsGql;
  /** GraphQL query type for retrieving SelfRegistration data */
  selfRegistrations?: Maybe<QuerySelfRegistrationGql>;
  /** GraphQL query type for retrieving Units */
  units?: Maybe<QueryUnitsGql>;
  /** Query for getting systems Primary Color */
  uploadLimit: Scalars['Int']['output'];
  /** GraphQL queries for retrieving and exporting User related data like: groups, certificates, statistics */
  users: QueryUserGql;
  /** Query for retriving the version */
  version: Scalars['String']['output'];
  /** GraphQL query type for retrieving different kinds of Widgeds based on user roles */
  widgets: QueryWidgetsGql;
  /** Query for getting the X-Editor URL */
  xEditorUrl: Scalars['String']['output'];
};

/** Queries related to Assistant */
export type QueryAssistant = {
  __typename?: 'QueryAssistant';
  getUrls: AssistantGql;
};

/** GraphQL queries related to badge notifications */
export type QueryBadgeNotificationsGql = {
  __typename?: 'QueryBadgeNotificationsGQL';
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  notificationBadgeForUser?: Maybe<BadgeNotificationsDto>;
  userBadges?: Maybe<Array<Maybe<UserBadgesDto>>>;
};

/** GraphQL queries related to badges */
export type QueryBadgesGql = {
  __typename?: 'QueryBadgesGQL';
  allCourseBadges: Array<BadgeDto>;
  allSystemBadges: Array<Maybe<BadgeDto>>;
  byIdCourseBadge: Badges;
  byIdSystemBadge: Badges;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
};


/** GraphQL queries related to badges */
export type QueryBadgesGqlAllCourseBadgesArgs = {
  language: LocalizationEnum;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** GraphQL queries related to badges */
export type QueryBadgesGqlAllSystemBadgesArgs = {
  language: LocalizationEnum;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** GraphQL queries related to badges */
export type QueryBadgesGqlByIdCourseBadgeArgs = {
  idOrKey: IdOrKeyInput;
};


/** GraphQL queries related to badges */
export type QueryBadgesGqlByIdSystemBadgeArgs = {
  idOrKey: IdOrKeyInput;
};

/** Queries related to Categories/Topics */
export type QueryCategoriesGql = {
  __typename?: 'QueryCategoriesGQL';
  all: Array<Maybe<Category>>;
  /** Categories that hold at least one course published to the catalog. Used by the topic/category filter of the catalog. */
  allCatalogCategories: Array<Maybe<Category>>;
  allCategoriesList: Array<Maybe<Category>>;
  allEnrolledCourses: PaginatedResultOfScorm12EnrolledCourseDto;
  /** Categories that hold at least one course the current user has in the learning space. Used by the topic/category filter of the learning space. */
  allLearningSpaceCategories: Array<Maybe<Category>>;
  allNonEmptyCourseListCategories: Array<Maybe<Category>>;
  allWithFilters: PaginatedResultOfCategoryRefactor;
  byId: Category;
  enrolledCourses: PaginatedResultOfScorm12EnrolledCourseDto;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  simpleCategories: Array<Maybe<CategoryDto>>;
};


/** Queries related to Categories/Topics */
export type QueryCategoriesGqlAllArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  status: CourseCompletionStatus;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Categories/Topics */
export type QueryCategoriesGqlAllCatalogCategoriesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  status: CourseCompletionStatus;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Categories/Topics */
export type QueryCategoriesGqlAllEnrolledCoursesArgs = {
  categoryUuid?: InputMaybe<Scalars['String']['input']>;
  completionStatus?: CourseCompletionStatus;
  isOnlyMandatory?: Scalars['Boolean']['input'];
  mediaTypes?: InputMaybe<Array<MediaType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortingFilter?: EnrolledCourseSorting;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Categories/Topics */
export type QueryCategoriesGqlAllLearningSpaceCategoriesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  status: CourseCompletionStatus;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Categories/Topics */
export type QueryCategoriesGqlAllNonEmptyCourseListCategoriesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  status: CourseCompletionStatus;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Categories/Topics */
export type QueryCategoriesGqlAllWithFiltersArgs = {
  filters?: InputMaybe<TopicsFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  status: CourseCompletionStatus;
  take: Scalars['Int']['input'];
};


/** Queries related to Categories/Topics */
export type QueryCategoriesGqlByIdArgs = {
  idOrKey: IdOrKeyInput;
};


/** Queries related to Categories/Topics */
export type QueryCategoriesGqlEnrolledCoursesArgs = {
  categoryUuid?: InputMaybe<Scalars['String']['input']>;
  isOnlyMandatory?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status: CourseCompletionStatus;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Categories/Topics */
export type QueryCategoriesGqlSimpleCategoriesArgs = {
  isOnlyMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  pageIndex?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status: CourseCompletionStatus;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** GraphQL queries  related to certificates */
export type QueryCertificatesGql = {
  __typename?: 'QueryCertificatesGQL';
  all: Array<Maybe<Certificate>>;
  byId: Certificate;
  certificatePreview: CertPreviewGql;
  generateCertificate: CertGenerateGql;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  userLocal?: Maybe<Scalars['String']['output']>;
};


/** GraphQL queries  related to certificates */
export type QueryCertificatesGqlAllArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** GraphQL queries  related to certificates */
export type QueryCertificatesGqlByIdArgs = {
  idOrKey: IdOrKeyInput;
};


/** GraphQL queries  related to certificates */
export type QueryCertificatesGqlCertificatePreviewArgs = {
  input: CertificatePreviewInput;
};


/** GraphQL queries  related to certificates */
export type QueryCertificatesGqlGenerateCertificateArgs = {
  input: CertificateDownloadInput;
};


/** GraphQL queries  related to certificates */
export type QueryCertificatesGqlUserLocalArgs = {
  idOrKey?: InputMaybe<IdOrKeyInput>;
};

/** Queries related to application Configs */
export type QueryConfigGql = {
  __typename?: 'QueryConfigGQL';
  configData: Config;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
};

/** GraphQL queries for dashboard statistics across different areas of the application */
export type QueryDashboardStatistics = {
  __typename?: 'QueryDashboardStatistics';
  dashboardStatistics: DashboardStatisticDto;
};


/** GraphQL queries for dashboard statistics across different areas of the application */
export type QueryDashboardStatisticsDashboardStatisticsArgs = {
  filter: DashboardFilter;
};

/** Queries related to Email Templates */
export type QueryEmailTemplatesGql = {
  __typename?: 'QueryEmailTemplatesGQL';
  all: Array<Maybe<Mailtemplate>>;
  byId: Mailtemplate;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
};


/** Queries related to Email Templates */
export type QueryEmailTemplatesGqlAllArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Email Templates */
export type QueryEmailTemplatesGqlByIdArgs = {
  idOrKey: IdOrKeyInput;
};

export type QueryEvaluationsGql = {
  __typename?: 'QueryEvaluationsGQL';
  myRatings: Array<Maybe<CourseEvaluationGql>>;
};

/** Queries related to Events */
export type QueryEventsGql = {
  __typename?: 'QueryEventsGQL';
  byId?: Maybe<Event>;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
};


/** Queries related to Events */
export type QueryEventsGqlByIdArgs = {
  uuid: Scalars['UUID']['input'];
};

/** Queries related to Groups */
export type QueryGroupsGql = {
  __typename?: 'QueryGroupsGQL';
  all: Array<Maybe<Group>>;
  allFiltered: PaginatedResultOfGroupRefactored;
  byId: Group;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
};


/** Queries related to Groups */
export type QueryGroupsGqlAllArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Groups */
export type QueryGroupsGqlAllFilteredArgs = {
  filters?: InputMaybe<GroupsFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Groups */
export type QueryGroupsGqlByIdArgs = {
  idOrKey: IdOrKeyInput;
};

/** Queries related to HelpAdmin */
export type QueryHelpAdminGql = {
  __typename?: 'QueryHelpAdminGQL';
  helpAdminData: HelpAdmin_Output;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  removeHelpAdminData: Scalars['Int']['output'];
};

/** GraphQL queries related to icons */
export type QueryIconGql = {
  __typename?: 'QueryIconGQL';
  allIcons: Array<Maybe<Icon>>;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
};


/** GraphQL queries related to icons */
export type QueryIconGqlAllIconsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMailLog = {
  __typename?: 'QueryMailLog';
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  /** Get a mail log by its ID. */
  mailLogById: MailLog;
  /** Get paginated mail logs. */
  paginatedMailLogs: PaginatedResultOfMailLog;
};


export type QueryMailLogMailLogByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMailLogPaginatedMailLogsArgs = {
  filters?: InputMaybe<MailLogFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Queries related to Medias */
export type QueryMediaGql = {
  __typename?: 'QueryMediaGQL';
  all: PaginatedResultOfMediaGqlRefactored;
};


/** Queries related to Medias */
export type QueryMediaGqlAllArgs = {
  filters?: InputMaybe<MediaFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Queries related to Menu configuration */
export type QueryMenuConfigurationGql = {
  __typename?: 'QueryMenuConfigurationGQL';
  contexts: Array<Maybe<Context>>;
  menu: Array<Maybe<Menu_Configuration>>;
  menuItem: Menu_Configuration;
};


/** Queries related to Menu configuration */
export type QueryMenuConfigurationGqlMenuItemArgs = {
  idOrKey: IdOrKeyInput;
};

/** Queries related to Module Preference */
export type QueryModulePreferenceGql = {
  __typename?: 'QueryModulePreferenceGQL';
  modulePreferences?: Maybe<Array<Maybe<Module_Preference>>>;
  preference?: Maybe<Module_Preference>;
};


/** Queries related to Module Preference */
export type QueryModulePreferenceGqlModulePreferencesArgs = {
  moduleName?: InputMaybe<Scalars['String']['input']>;
};


/** Queries related to Module Preference */
export type QueryModulePreferenceGqlPreferenceArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryNews = {
  __typename?: 'QueryNews';
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  newsById: News;
  newsByUserId: NewsConnectionGql;
  newsForLoggedUser: NewsConnectionGql;
  newsOfLoggedCreator: NewsConnectionGql;
};


export type QueryNewsNewsByIdArgs = {
  newsUuid: Scalars['UUID']['input'];
};


export type QueryNewsNewsByUserIdArgs = {
  input?: InputMaybe<IdOrKeyInput>;
};


export type QueryNewsNewsOfLoggedCreatorArgs = {
  filters?: InputMaybe<NewsFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** GraphQL queries related to nuggets */
export type QueryNuggetGql = {
  __typename?: 'QueryNuggetGQL';
  allTaskStatistics?: Maybe<Array<Maybe<TaskDto>>>;
  allTasks?: Maybe<Array<Maybe<TaskDto>>>;
  exportTaskLearnersStatistics?: Maybe<ExportBase64Gql>;
  exportTaskStatistics?: Maybe<ExportBase64Gql>;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  itemUploadStatus?: Maybe<Item_Upload_Status>;
  reusableNuggets?: Maybe<Array<Maybe<ReusableNuggetDto>>>;
  taskById?: Maybe<Array<Maybe<TaskDto>>>;
};


/** GraphQL queries related to nuggets */
export type QueryNuggetGqlAllTaskStatisticsArgs = {
  filters?: InputMaybe<TasksFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL queries related to nuggets */
export type QueryNuggetGqlAllTasksArgs = {
  filters?: InputMaybe<TasksFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL queries related to nuggets */
export type QueryNuggetGqlExportTaskLearnersStatisticsArgs = {
  idOrKey: IdOrKeyInput;
};


/** GraphQL queries related to nuggets */
export type QueryNuggetGqlItemUploadStatusArgs = {
  courseId: Scalars['Int']['input'];
};


/** GraphQL queries related to nuggets */
export type QueryNuggetGqlReusableNuggetsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL queries related to nuggets */
export type QueryNuggetGqlTaskByIdArgs = {
  filters?: InputMaybe<TasksFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  task: Scalars['UUID']['input'];
};

export type QueryParentGql = {
  __typename?: 'QueryParentGQL';
  all?: Maybe<ParentConnectionGql>;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
};


export type QueryParentGqlAllArgs = {
  filters?: InputMaybe<ParentsFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Queries related to Roles */
export type QueryRoles = {
  __typename?: 'QueryRoles';
  all: Array<Maybe<Role>>;
  byId: Role;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  promotionRoles: Array<Maybe<Role>>;
};


/** Queries related to Roles */
export type QueryRolesAllArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Roles */
export type QueryRolesByIdArgs = {
  idOrKey: Scalars['ID']['input'];
};

/** Query related to Scorm12Items */
export type QueryScorm12ItemsGql = {
  __typename?: 'QuerySCORM12ItemsGQL';
  all: ScoConnectionGql;
  byId: Scorm12Item;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  learningTypes?: Maybe<Scorm12Item>;
};


/** Query related to Scorm12Items */
export type QueryScorm12ItemsGqlAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ScoConnectionGqlSortInput>>;
  where?: InputMaybe<ScoConnectionGqlFilterInput>;
};


/** Query related to Scorm12Items */
export type QueryScorm12ItemsGqlByIdArgs = {
  idOrKey: IdOrKeyInput;
};

/** Query ItemAttempts */
export type QueryScorm12Attempts = {
  __typename?: 'QueryScorm12Attempts';
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  lastVisitedLesson?: Maybe<AttemptGql>;
};


/** Query ItemAttempts */
export type QueryScorm12AttemptsLastVisitedLessonArgs = {
  courseIdOrKey: IdOrKeyInput;
};

/** Queries related to Scorm12Courses */
export type QueryScorm12Courses = {
  __typename?: 'QueryScorm12Courses';
  all: CourseConnectionGql;
  allLearningPaths: Array<Maybe<Scorm12Course>>;
  assignOptions: Group;
  assignmentOverview: PaginatedResultOfMediaDetailsStatisticsGql;
  byId: Scorm12Course;
  catalogItemsByIds: Array<Maybe<Scorm12Course>>;
  catalogue: PaginatedResultOfScorm12Course;
  /** Content overview report: all content in scope (also unassigned) with server-side search, filter, sort, paging and KPI summary */
  contentOverview: ContentOverviewPage;
  dashboardMode: DashboardMode;
  /** Xlsx export of the content overview: all matching rows, or only the given ids (search and filter are ignored then) */
  exportContentOverview: ExportBase64Gql;
  exportMediaDetailsStatistics: ExportBase64Gql;
  exportMediaRecurringStatistics: ExportBase64Gql;
  exportMediaStatistics: ExportBase64Gql;
  /** Xlsx export of the user progress report: all matching rows, or only the given row ids (search and filter are ignored then) */
  exportUserProgress: ExportBase64Gql;
  fileExists: Scalars['Boolean']['output'];
  hasMoreThanTreeLevels: Scalars['Boolean']['output'];
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  mediaStatistics: Array<Maybe<MediaStatisticsOverview>>;
  uploadStatus: Upload_Status;
  /** User progress report: one row per learner and content item with server-side search, filter, sort, paging and KPI summary */
  userProgress: UserProgressPage;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesAllArgs = {
  order?: InputMaybe<Array<CourseConnectionGqlSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CourseConnectionGqlFilterInput>;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesAssignOptionsArgs = {
  course?: InputMaybe<IdOrKeyInput>;
  group?: InputMaybe<IdOrKeyInput>;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesAssignmentOverviewArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesByIdArgs = {
  idOrKey: IdOrKeyInput;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesCatalogItemsByIdsArgs = {
  idOrKeys: Array<InputMaybe<IdOrKeyInput>>;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesCatalogueArgs = {
  categoryUuid?: InputMaybe<Scalars['String']['input']>;
  filterByFavourites: Scalars['Boolean']['input'];
  isBooked?: InputMaybe<Scalars['Boolean']['input']>;
  mediaTypes?: InputMaybe<Array<MediaType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortingCondition: CatalogSortingItems;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesContentOverviewArgs = {
  filter?: InputMaybe<ContentOverviewFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<ContentOverviewSortInput>>>;
  take?: Scalars['Int']['input'];
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesDashboardModeArgs = {
  idOrKey: IdOrKeyInput;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesExportContentOverviewArgs = {
  filter?: InputMaybe<ContentOverviewFilterInput>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ContentOverviewSortInput>>>;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesExportMediaDetailsStatisticsArgs = {
  idOrKey: IdOrKeyInput;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesExportMediaRecurringStatisticsArgs = {
  input: ExportRecurringInput;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesExportUserProgressArgs = {
  filter?: InputMaybe<UserProgressFilterInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserProgressSortInput>>>;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesFileExistsArgs = {
  uuid: Scalars['UUID']['input'];
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesHasMoreThanTreeLevelsArgs = {
  idOrKey: IdOrKeyInput;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesMediaStatisticsArgs = {
  filters?: InputMaybe<MediaStatisticsFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Scorm12Courses */
export type QueryScorm12CoursesUserProgressArgs = {
  filter?: InputMaybe<UserProgressFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<UserProgressSortInput>>>;
  take?: Scalars['Int']['input'];
};

/** Queries related to Scorm12EnrolledCourses */
export type QueryScorm12EnrolledCourses = {
  __typename?: 'QueryScorm12EnrolledCourses';
  addEntryCount: Scalars['Boolean']['output'];
  all: Scorm12EnrolledCourseConnection;
  byId: Scorm12EnrolledCourse;
  calendarData: Scorm12EnrolledCourseConnection;
  calendarDataByUserId: Scorm12EnrolledCourseConnection;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  myCourses: Scorm12EnrolledCourseConnection;
};


/** Queries related to Scorm12EnrolledCourses */
export type QueryScorm12EnrolledCoursesAddEntryCountArgs = {
  idOrKey: IdOrKeyInput;
};


/** Queries related to Scorm12EnrolledCourses */
export type QueryScorm12EnrolledCoursesByIdArgs = {
  idOrKey: IdOrKeyInput;
};


/** Queries related to Scorm12EnrolledCourses */
export type QueryScorm12EnrolledCoursesCalendarDataByUserIdArgs = {
  input?: InputMaybe<IdOrKeyInput>;
};


/** Queries related to Scorm12EnrolledCourses */
export type QueryScorm12EnrolledCoursesMyCoursesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySelfRegistrationGql = {
  __typename?: 'QuerySelfRegistrationGQL';
  acceptanceList: Array<Maybe<User>>;
  /** Queries for retriving SelfRegistration data */
  all: Array<Maybe<SelfRegistrationGql>>;
  byId: SelfRegistrationGql;
};


export type QuerySelfRegistrationGqlAllArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySelfRegistrationGqlByIdArgs = {
  idOrKey: IdOrKeyInput;
};

/** Queries related to Units */
export type QueryUnitsGql = {
  __typename?: 'QueryUnitsGQL';
  all: Array<Maybe<Unit>>;
  allDropDown: Array<Maybe<Unit>>;
  byId: Unit;
  defaultUnit: Default_Unit;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
};


/** Queries related to Units */
export type QueryUnitsGqlByIdArgs = {
  idOrKey: IdOrKeyInput;
};

/** Queries related to media upload accessibility */
export type QueryUploadAccessibilityGql = {
  __typename?: 'QueryUploadAccessibilityGQL';
  aiInstruction: CourseUploadAccessibility;
  badge: CourseUploadAccessibility;
  calendarWidget: CourseUploadAccessibility;
  chatbot: CourseUploadAccessibility;
  courseMailingStatus: CourseUploadAccessibility;
  courseRecommendationStatus: CourseUploadAccessibility;
  courseUploadAccessibilityStatus: CourseUploadAccessibility;
  evaluation: CourseUploadAccessibility;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  learningPath?: Maybe<CourseUploadAccessibility>;
  lti: CourseUploadAccessibility;
  maintenance: CourseUploadAccessibility;
  parent: CourseUploadAccessibility;
  task: CourseUploadAccessibility;
  usermanagementByExternalIdm: CourseUploadAccessibility;
  zulipChat: CourseUploadAccessibility;
};

/** Queries related to Users */
export type QueryUserGql = {
  __typename?: 'QueryUserGQL';
  all?: Maybe<UserConnectionGql>;
  bulkExportUsers: ExportBase64Gql;
  byId: User;
  currentUser: User;
  /** Everything the admin user details show about a user. Admins see every user; education managers only users of the groups they manage, and only through those groups */
  details: UserDetails;
  downloadCSVTemplate: ExportBase64Gql;
  downloadExcelTemplate: ExportBase64Gql;
  exportUserDetailsStatistics: ExportBase64Gql;
  exportUserRecurringStatistics: ExportBase64Gql;
  exportUserStatistics: ExportBase64Gql;
  getCertificates: User;
  getGroups: User;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  importLogs: Array<Maybe<ImportUsers>>;
  importLogsFiltered: PaginatedResultOfImportUsersRefactor;
  learningManagers: Array<Maybe<User>>;
  loggedUserChildUuid: User;
  systemLanguage: Array<Maybe<Scalars['String']['output']>>;
  userStatistics: Array<Maybe<UserStatisticsOverviewGql>>;
  usersOfByUserRole: UserConnectionGql;
};


/** Queries related to Users */
export type QueryUserGqlAllArgs = {
  filters?: InputMaybe<UsersFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Users */
export type QueryUserGqlBulkExportUsersArgs = {
  input: BulkExportUsersInput;
};


/** Queries related to Users */
export type QueryUserGqlByIdArgs = {
  idOrKey?: InputMaybe<IdOrKeyInput>;
};


/** Queries related to Users */
export type QueryUserGqlDetailsArgs = {
  idOrKey: IdOrKeyInput;
};


/** Queries related to Users */
export type QueryUserGqlExportUserDetailsStatisticsArgs = {
  idOrKey: IdOrKeyInput;
};


/** Queries related to Users */
export type QueryUserGqlExportUserRecurringStatisticsArgs = {
  input: ExportRecurringInput;
};


/** Queries related to Users */
export type QueryUserGqlGetCertificatesArgs = {
  profileSorting?: InputMaybe<ProfileSortingItems>;
};


/** Queries related to Users */
export type QueryUserGqlGetGroupsArgs = {
  profileSorting?: InputMaybe<ProfileSortingItems>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Users */
export type QueryUserGqlImportLogsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Users */
export type QueryUserGqlImportLogsFilteredArgs = {
  filters?: InputMaybe<ImportLogsFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Users */
export type QueryUserGqlLearningManagersArgs = {
  unitUuid?: InputMaybe<Scalars['String']['input']>;
};


/** Queries related to Users */
export type QueryUserGqlUserStatisticsArgs = {
  filters?: InputMaybe<UsersStatisticsFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries related to Users */
export type QueryUserGqlUsersOfByUserRoleArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Queris related to Widgets */
export type QueryWidgetsGql = {
  __typename?: 'QueryWidgetsGQL';
  all: WidgetsConnectionGql;
  averageLerarningTime: AverageLearningTimeWidget;
  courseCompletionsInPerdiod: CourseCompletionsGql;
  coursesWidgetData: Array<Maybe<CourseHistoryAndLastVisitedWidget>>;
  /** Convenience property, will always return ## - to make Apollo and BananaCakePop happy */
  id: Scalars['ID']['output'];
  lastCompletions: Array<Maybe<Scorm12EnrolledCourse>>;
  latestFromCatalogue: Array<Maybe<LatestCatalogueWidget>>;
  myBadges: Array<Maybe<BadgeCollection>>;
  myCertificates: Array<Maybe<MyCertificates>>;
  myLastCompletions: Array<Maybe<Scorm12EnrolledCourse>>;
  newestMembers: Array<Maybe<User>>;
};


/** Queris related to Widgets */
export type QueryWidgetsGqlAverageLerarningTimeArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};


/** Queris related to Widgets */
export type QueryWidgetsGqlCourseCompletionsInPerdiodArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};


/** Queris related to Widgets */
export type QueryWidgetsGqlCoursesWidgetDataArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  status: CourseCompletionStatus;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queris related to Widgets */
export type QueryWidgetsGqlLastCompletionsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queris related to Widgets */
export type QueryWidgetsGqlLatestFromCatalogueArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queris related to Widgets */
export type QueryWidgetsGqlMyBadgesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queris related to Widgets */
export type QueryWidgetsGqlMyCertificatesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queris related to Widgets */
export type QueryWidgetsGqlMyLastCompletionsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Queris related to Widgets */
export type QueryWidgetsGqlNewestMembersArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Queries zulip chat */
export type QueryZulip = {
  __typename?: 'QueryZulip';
  checkStreamExists: Scalars['Boolean']['output'];
  hasUnreadMessages: Scalars['Boolean']['output'];
  markMessagesAsRead: Scalars['Boolean']['output'];
  messages: ZulipStreamGql;
  topics: Array<Maybe<ZulipTopicGql>>;
};


/** Queries zulip chat */
export type QueryZulipCheckStreamExistsArgs = {
  courseUuid: Scalars['String']['input'];
};


/** Queries zulip chat */
export type QueryZulipHasUnreadMessagesArgs = {
  courseUuid: Scalars['String']['input'];
};


/** Queries zulip chat */
export type QueryZulipMarkMessagesAsReadArgs = {
  courseUuid: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


/** Queries zulip chat */
export type QueryZulipMessagesArgs = {
  courseUuid: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


/** Queries zulip chat */
export type QueryZulipTopicsArgs = {
  courseUuid: Scalars['String']['input'];
};

export enum RelativeTimeUnitEnum {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type ResponseWrapperOfBoolean = {
  __typename?: 'ResponseWrapperOfBoolean';
  data: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode: HttpStatusCode;
};

export type ReusableNuggetDto = {
  __typename?: 'ReusableNuggetDto';
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  learningPathDetails?: Maybe<Array<Maybe<LearningPathDetail>>>;
  title?: Maybe<LangString>;
  topic?: Maybe<LangString>;
  type: MediaType;
  uuid: Scalars['UUID']['output'];
};

/**
 * A Role in the system.
 * Example:
 * - Admin
 * - Education-Manager
 * - Learner
 *
 */
export type Role = {
  __typename?: 'Role';
  description: LangString;
  /** One or more privileges that make this role */
  grantedPrivileges: Array<Maybe<Privilege>>;
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  name?: Maybe<LangString>;
  uuid: Scalars['UUID']['output'];
};

/** GraphQL mutation for updating and upserting Roles */
export type RoleMutationGql = {
  __typename?: 'RoleMutationGQL';
  upsert: Role;
};


/** GraphQL mutation for updating and upserting Roles */
export type RoleMutationGqlUpsertArgs = {
  input: UpsertRoleInput;
};

export type ScoConnectionGql = {
  __typename?: 'SCOConnectionGQL';
  edges: Array<ScoEdgeGql>;
  nodes: Array<Scorm12Item>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScoConnectionGqlFilterInput = {
  and?: InputMaybe<Array<ScoConnectionGqlFilterInput>>;
  or?: InputMaybe<Array<ScoConnectionGqlFilterInput>>;
  totalCount?: InputMaybe<IntOperationFilterInput>;
};

export type ScoConnectionGqlSortInput = {
  totalCount?: InputMaybe<SortEnumType>;
};

export type ScoEdgeGql = {
  __typename?: 'SCOEdgeGQL';
  cursor: Scalars['String']['output'];
  node: Scorm12Item;
};

/** A course */
export type Scorm12Course = {
  __typename?: 'SCORM12Course';
  /** All badges */
  allBadges: Array<Maybe<Badges>>;
  /** All categories */
  allCategories: Array<Maybe<Category>>;
  /** All certificates */
  allCertificates: Array<Maybe<Certificate>>;
  /** All groups */
  allGroups: Array<Maybe<Group>>;
  /** Assigned category names concatenated with comma */
  assignedCategories?: Maybe<Scalars['String']['output']>;
  /** Assigned categories count */
  assignedCategoriesCount: Scalars['Int']['output'];
  /** Assigned groups count */
  assignedGroupsCount: Scalars['Int']['output'];
  /** Assigned learners */
  assignedLearners?: Maybe<Array<Maybe<MediaDetailsStatisticsGql>>>;
  /** Who may see the course in the catalog: ALL_USERS or GROUPS. Only meaningful while showInCatalog is true. */
  catalogAudience: CatalogAudienceEnum;
  /** Uuids of the groups the course is offered to when catalogAudience is GROUPS. */
  catalogGroupUuids?: Maybe<Array<Scalars['UUID']['output']>>;
  /** Categories assigned to the course */
  categories: Array<Maybe<Category>>;
  /** Categories not assigned to the course */
  categoriesNotAssigned: Array<Maybe<Category>>;
  /** Count of chapters */
  chaptersCount: Scalars['Int']['output'];
  /** Course evaluation */
  courseEvaluations: Array<Maybe<CourseEvaluationGql>>;
  /** Course media URL */
  courseMediaURL?: Maybe<Scalars['String']['output']>;
  /** Defines uuid of the course */
  courseUuid: Scalars['String']['output'];
  /** Returns full name of the creator */
  createdBy: Scalars['String']['output'];
  /** Date when Course was created. */
  createdDate: Scalars['Instant']['output'];
  /** Dashboard Mode */
  dashboardMode: DashboardMode;
  /** Defines description of the course */
  description: LangString;
  /** Enable Badge */
  enableBadge?: Maybe<CourseUploadAccessibility>;
  /** Enable Dashboard Mode */
  enableDashboardMode: Scalars['Boolean']['output'];
  /** Course enrolled details */
  enrolledDetails?: Maybe<MediaDetailsStatisticsGql>;
  enrollment?: Maybe<Scorm12EnrolledCourse>;
  /** Date when Course is expired. */
  expirationDate?: Maybe<Scalars['Instant']['output']>;
  /** External launch URL (populated for LTI courses; null otherwise). */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Groups assigned to the course */
  groups: Array<Maybe<Group>>;
  /** Groups not assigned to the course */
  groupsNotAssigned: Array<Maybe<Group>>;
  /** Check if there is a draft version for the course */
  hasDraft?: Maybe<Scalars['Boolean']['output']>;
  /** HistoryData */
  historyData: Array<Maybe<CourseVersionGql>>;
  id: Scalars['ID']['output'];
  /**
   * Image
   * @deprecated Use imageUrl
   */
  image?: Maybe<Scalars['String']['output']>;
  /**
   * Image Type
   * @deprecated Use imageUrl
   */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Cacheable, public tile image URL. Null when the course has no image. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Defines if the course is active */
  isActive: Scalars['Boolean']['output'];
  /** Defines if user allowed to edit course */
  isAllowedToEdit: Scalars['Boolean']['output'];
  /** Defines if the course is booked */
  isBooked: Scalars['Boolean']['output'];
  /** Defines if the course is booked from Catalog */
  isCatalog: Scalars['Boolean']['output'];
  /** Check if zulip chat is enabled for the course */
  isChatEnabled: Scalars['Boolean']['output'];
  /** Defines if the course is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Defines if user allowed to edit course */
  isEditableByOthers: Scalars['Boolean']['output'];
  /** Defines if the course is favourite for the logged in user */
  isFavourite: Scalars['Boolean']['output'];
  /** Check if the course is a learning path */
  isLearningPath: Scalars['Boolean']['output'];
  /** Defines if user allowed to change editable value */
  isOwnerOrAdmin: Scalars['Boolean']['output'];
  /** Defines if the course is published */
  isPublished: Scalars['Boolean']['output'];
  /** Is task completed or started */
  isTaskCompletedOrStarted: Scalars['Boolean']['output'];
  /** Course item identifier */
  itemIdentifier: Scalars['String']['output'];
  items?: Maybe<Array<Maybe<Scorm12Item>>>;
  key: Scalars['Key']['output'];
  /** Language */
  language: Scalars['String']['output'];
  /** Last publish date */
  lastPublishDate?: Maybe<Scalars['Instant']['output']>;
  /** Count of chapters */
  learningPathChaptersCount: Scalars['Int']['output'];
  /** Count of lessons */
  learningPathLessonsCount: Scalars['Int']['output'];
  /** Calls the SCOs of the course */
  learningPathScos: Array<Maybe<Scorm12Item>>;
  /** Count of lessons */
  lessonsCount: Scalars['Int']['output'];
  /** Media type */
  mediaType: MediaType;
  /** MIT Custom Tag */
  mit?: Maybe<Scalars['String']['output']>;
  /** Defines name of the course */
  name: LangString;
  /** Overall rating averaged from active evaluations, rounded to nearest 0.5 */
  overallRating?: Maybe<Scalars['Float']['output']>;
  /** Calls the SCOs of the course */
  scos: Array<Maybe<Scorm12Item>>;
  /** Selected Badge */
  selectedBadge?: Maybe<Badges>;
  /** Selected certificate */
  selectedCertificate?: Maybe<Certificate>;
  /** Defines if the course is shown in catalog */
  showInCatalog: Scalars['Boolean']['output'];
  /** Total learning time */
  totalLearningTime?: Maybe<Scalars['Duration']['output']>;
  /** Count of items that have a launch uri (are trackable) */
  trackableItems: Scalars['Int']['output'];
  /** Typical Learning Time (when set) */
  typicalLearningTime?: Maybe<Scalars['Duration']['output']>;
  /** Date when Course was last updated. */
  updatedDate: Scalars['Instant']['output'];
  uuid: Scalars['UUID']['output'];
  /** Current Version */
  version?: Maybe<Scalars['String']['output']>;
  /** Video Or Pdf Content */
  videoOrPdfContent?: Maybe<FileInfoResult>;
};

/** GraphQL mutation for updating course completion status and commiting an attempt to the database */
export type Scorm12AttemptMutation = {
  __typename?: 'Scorm12AttemptMutation';
  commit: Scorm12EnrolledItem;
  launchSco: LaunchScoResult;
};


/** GraphQL mutation for updating course completion status and commiting an attempt to the database */
export type Scorm12AttemptMutationCommitArgs = {
  input: CommitScorm12AttemptInput;
};


/** GraphQL mutation for updating course completion status and commiting an attempt to the database */
export type Scorm12AttemptMutationLaunchScoArgs = {
  enrolledCourseLink: IdOrKeyInput;
  itemLink: IdOrKeyInput;
};

export type Scorm12CourseDto = {
  __typename?: 'Scorm12CourseDto';
  assignedCategories?: Maybe<Scalars['String']['output']>;
  courseEvaluations?: Maybe<Array<Maybe<CourseEvaluationDto>>>;
  courseMediaURL?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserDto>;
  createdById?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['Instant']['output'];
  deletedDate?: Maybe<Scalars['Instant']['output']>;
  description?: Maybe<LangString>;
  expirationDate?: Maybe<Scalars['Instant']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use imageUrl instead. */
  image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use imageUrl instead. */
  imageType?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lessonsCount?: Maybe<Scalars['Int']['output']>;
  mediaType?: Maybe<MediaType>;
  name?: Maybe<LangString>;
  overallRating?: Maybe<Scalars['Float']['output']>;
  publishStatus: PublishStatus;
  scos?: Maybe<Array<Maybe<ScosDto>>>;
  selectedCertificate?: Maybe<CertificateDto>;
  showInCatalog: Scalars['Boolean']['output'];
  typicalLearningTime?: Maybe<Scalars['Duration']['output']>;
  updatedBy?: Maybe<UserDto>;
  updatedById?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['Instant']['output'];
  uuid: Scalars['UUID']['output'];
};

/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutation = {
  __typename?: 'Scorm12CourseMutation';
  activateCatalog: Scorm12Course;
  /** Sets the catalog audience of a course and, for GROUPS, the groups allowed to see and book it. The group list replaces the previous selection. */
  activateCatalogForGroups: Scorm12Course;
  activateMedia: Scorm12Course;
  assignMediaToGroup: Array<Maybe<Scorm12Course>>;
  batchUpsert: Array<Maybe<Scorm12Course>>;
  bookCourse: Scorm12EnrolledCourse;
  bulkActivateCatalog: Array<Maybe<Scorm12Course>>;
  bulkActivateMedia: Array<Maybe<Scorm12Course>>;
  bulkDeleteMedia: Array<Maybe<Scorm12Course>>;
  bulkUpdateMediaCategories: Array<Maybe<Scorm12Course>>;
  bulkUpdateMediaGroups: Array<Maybe<Scorm12Course>>;
  bulkUpsert: Array<Maybe<Scorm12Course>>;
  changeCourseOwner: Array<Maybe<Scorm12Course>>;
  createAiCourse: Scorm12Course;
  createVersion: Scorm12Course;
  deactivateMedia: Array<Maybe<Scorm12Course>>;
  deleteCourseUploadStatus: Upload_Status;
  deleteMedia: Scorm12Course;
  deleteSubtitles: Scalars['Boolean']['output'];
  deleteVersion: Scorm12Course;
  duplicateLearningPath: Scorm12Course;
  enableChat: Scorm12Course;
  enrollStudent: Scorm12EnrolledCourse;
  /** Exports detailed (per learner) statistics for all medias the current user can access and e-mails the resulting xlsx file to the current user. Honours the same filters/search as the media statistics list. */
  exportAllMediasDetailsStatistics: Scalars['Boolean']['output'];
  generateUniqueKey?: Maybe<Scalars['String']['output']>;
  generateUniqueUuid: Scalars['UUID']['output'];
  publishLearningPath: Scorm12Course;
  remove: Scalars['Boolean']['output'];
  unBook: Scalars['Boolean']['output'];
  updateCourseMedia: Scalars['Int']['output'];
  updateMedia: Scalars['Boolean']['output'];
  updateMediaCategories: Scorm12Course;
  updateMediaGroups: Scorm12Course;
  uploadCourseMetadata?: Maybe<Array<Maybe<PreConfirmScorm12CourseGql>>>;
  uploadCourses?: Maybe<Array<Maybe<Scorm12Course>>>;
  uploadedFileInfo: FileInfoReturn;
  upsert: Scorm12Course;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationActivateCatalogArgs = {
  input: ActivateCatalogInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationActivateCatalogForGroupsArgs = {
  input: ActivateCatalogForGroupsInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationActivateMediaArgs = {
  input: ActivateMediaInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationAssignMediaToGroupArgs = {
  input: AssignCourseGroupInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationBatchUpsertArgs = {
  inputs: Array<InputMaybe<UpsertCourseInput>>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationBookCourseArgs = {
  input: BookCourseInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationBulkActivateCatalogArgs = {
  input: BulkActivateCatalogInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationBulkActivateMediaArgs = {
  input: BulkActivateMediaInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationBulkDeleteMediaArgs = {
  input: BulkDeleteMediaInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationBulkUpdateMediaCategoriesArgs = {
  input: BulkUpdateMediaCategoriesInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationBulkUpdateMediaGroupsArgs = {
  input: BulkUpdateMediaGroupsInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationBulkUpsertArgs = {
  inputs: Array<InputMaybe<UpsertCourseInput>>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationChangeCourseOwnerArgs = {
  input?: InputMaybe<ChangeCourseOwnerInput>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationCreateAiCourseArgs = {
  input: UpsertCourseInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationCreateVersionArgs = {
  courseUuid?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationDeactivateMediaArgs = {
  input: DeactivateMediaInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationDeleteMediaArgs = {
  input: DeleteMediaInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationDeleteSubtitlesArgs = {
  input?: InputMaybe<UpsertCourseInput>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationDeleteVersionArgs = {
  versionUuid?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationDuplicateLearningPathArgs = {
  input?: InputMaybe<UpsertCourseInput>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationEnableChatArgs = {
  courseUuid?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationEnrollStudentArgs = {
  input: EnrollStudentInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationExportAllMediasDetailsStatisticsArgs = {
  filters?: InputMaybe<MediaStatisticsFiltersInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationGenerateUniqueKeyArgs = {
  length?: Scalars['Int']['input'];
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationPublishLearningPathArgs = {
  input?: InputMaybe<PublishLearningPathInput>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationRemoveArgs = {
  input: UpsertRef2Input;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationUnBookArgs = {
  input: BookCourseInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationUpdateCourseMediaArgs = {
  input: UploadCourseInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationUpdateMediaArgs = {
  idOrKey: IdOrKeyInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationUpdateMediaCategoriesArgs = {
  input: UpdateMediaCategoriesInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationUpdateMediaGroupsArgs = {
  input: UpdateMediaGroupsInput;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationUploadCourseMetadataArgs = {
  inputs: Array<InputMaybe<UploadCourseInput>>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationUploadCoursesArgs = {
  inputs: Array<InputMaybe<UploadCourseInput>>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationUploadedFileInfoArgs = {
  input?: InputMaybe<UploadFileInput>;
};


/** GraphQL mutation for uploading and updating Scorm course related data */
export type Scorm12CourseMutationUpsertArgs = {
  input: UpsertCourseInput;
};

/** Details of one Media assigned to a User  */
export type Scorm12EnrolledCourse = {
  __typename?: 'Scorm12EnrolledCourse';
  calendarData?: Maybe<CalendarData>;
  /** Completion date */
  completionDate?: Maybe<Scalars['Instant']['output']>;
  completionStatus: CourseCompletionStatus;
  course: Scorm12Course;
  daysLeft?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  enrolledItems: Array<Maybe<Scorm12EnrolledItem>>;
  id: Scalars['ID']['output'];
  isFavourite: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  skipCelebrate: Scalars['Boolean']['output'];
  user: User;
  uuid: Scalars['UUID']['output'];
};


/** Details of one Media assigned to a User  */
export type Scorm12EnrolledCourseEnrolledItemsArgs = {
  filter?: InputMaybe<EnrolledItemFilterInput>;
};

export type Scorm12EnrolledCourseConnection = {
  __typename?: 'Scorm12EnrolledCourseConnection';
  edges: Array<Scorm12EnrolledCourseEdge>;
  nodes: Array<Scorm12EnrolledCourse>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Scorm12EnrolledCourseDto = {
  __typename?: 'Scorm12EnrolledCourseDto';
  completionDate?: Maybe<Scalars['String']['output']>;
  completionStatus: CourseCompletionStatus;
  course?: Maybe<Scorm12CourseDto>;
  daysLeft?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['Int']['output'];
  isFavourite: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  user?: Maybe<UserDto>;
  uuid: Scalars['UUID']['output'];
};

export type Scorm12EnrolledCourseEdge = {
  __typename?: 'Scorm12EnrolledCourseEdge';
  cursor: Scalars['String']['output'];
  node: Scorm12EnrolledCourse;
};

/** Scorm12EnrolledItemGQL */
export type Scorm12EnrolledItem = {
  __typename?: 'Scorm12EnrolledItem';
  commitApplied: Scalars['Boolean']['output'];
  commitSequence: Scalars['Int']['output'];
  course: Scorm12Course;
  /** Whether the user gets credit or not. */
  credit?: Maybe<Scalars['String']['output']>;
  enrolledCourse: Scorm12EnrolledCourse;
  /** Set by the LMS to indicate whether content is launched the first time or resumed */
  entry: Scorm12_Entry;
  id: Scalars['String']['output'];
  item: Scorm12Item;
  /** LessonLocation is used to resume the content at the same place */
  lessonLocation?: Maybe<Scalars['String']['output']>;
  /** Set by the content to determine completeness or success */
  lessonStatus: Scorm12_LessonStatus;
  /** The max score set by the content. Can be null when no score was set yet. */
  scoreMax?: Maybe<Scalars['Float']['output']>;
  /** The min score set by the content. Can be null when no score was set yet. */
  scoreMin?: Maybe<Scalars['Float']['output']>;
  /** The raw score set by the content. Can be null when no score was set yet. */
  scoreRaw?: Maybe<Scalars['Float']['output']>;
  /** Suspend data is used by the content to store arbitrary information and retrieve it later */
  suspendData?: Maybe<Scalars['String']['output']>;
  /** How much time did the user spent. */
  timeSpent: Scalars['Duration']['output'];
};

/** SCO (Shareable Content Object) Items are entities that can be launched and tracked by the LMS */
export type Scorm12Item = {
  __typename?: 'Scorm12Item';
  /** Archived Date */
  archivedDate?: Maybe<Scalars['Instant']['output']>;
  base64NuggetIcon?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  /** Completion Type */
  completionType?: Maybe<Scalars['String']['output']>;
  /** The course that this SCO belongs to. An SCO only belongs to exactly one Course. */
  course?: Maybe<Scorm12Course>;
  /** Defines when the SCO is created. */
  createdDate: Scalars['Instant']['output'];
  /** Defines a neccessary data that comes from imsmanifest.xml */
  dataFromLMS: Scalars['String']['output'];
  description: LangString;
  event?: Maybe<Event>;
  fileName?: Maybe<Scalars['String']['output']>;
  /** File Upload */
  fileUpload?: Maybe<Scalars['String']['output']>;
  /** Lesson Icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** Icon Upload */
  iconUpload?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Is Archived */
  isArchived: Scalars['Boolean']['output'];
  /** Check if the chapter is expanded */
  isExpanded?: Maybe<Scalars['Boolean']['output']>;
  /** Is nugget hidden */
  isHidden: Scalars['Boolean']['output'];
  /** Defines if item is mandatory */
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** Is Reusable Nugget */
  isReusable?: Maybe<Scalars['Boolean']['output']>;
  /** Is Task */
  isTask: Scalars['Boolean']['output'];
  isTrackable: Scalars['Boolean']['output'];
  /** Item Identifier */
  itemIdentifier?: Maybe<Scalars['String']['output']>;
  /** Item type */
  itemType?: Maybe<ItemType>;
  key: Scalars['Key']['output'];
  /** URI used to launch the SCO (from the imsmanifest.xml) */
  launchUri: Scalars['String']['output'];
  /** Item link */
  link?: Maybe<Scalars['String']['output']>;
  manifestId: Scalars['String']['output'];
  masteryScore?: Maybe<Scalars['Float']['output']>;
  maxTimeAllowed?: Maybe<Scalars['Duration']['output']>;
  /** Media type */
  mediaType: MediaType;
  /** Defines the metadata of the SCO data */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Raw <mit-type> string from the imsmanifest (e.g. "Video", "Fundamentals", "Knowledge check") when present. */
  mitType?: Maybe<Scalars['String']['output']>;
  /** Defines the order of the SCO data */
  order: Scalars['Int']['output'];
  parent?: Maybe<Scorm12Item>;
  /** Mit custom tag - subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  timeLimitAction: Scorm12_TimeLimitAction;
  /** Name of the SCO */
  title: LangString;
  /** Media type as string (e.g. "Link", "Task") — derived from MediaType. */
  type?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Scalars['String']['output']>>;
  /** Typical Learning Time (when set) */
  typicalLearningTime?: Maybe<Scalars['Duration']['output']>;
  /** Defines when the SCO is updated. */
  updatedDate: Scalars['Instant']['output'];
  uuid: Scalars['UUID']['output'];
};

/** GraphQl mutation for updating, upserting and removing the ScormItems */
export type Scorm12ItemMutation = {
  __typename?: 'Scorm12ItemMutation';
  remove: Scalars['Boolean']['output'];
  upsert: Scorm12Item;
};


/** GraphQl mutation for updating, upserting and removing the ScormItems */
export type Scorm12ItemMutationRemoveArgs = {
  input: UpsertRef2Input;
};


/** GraphQl mutation for updating, upserting and removing the ScormItems */
export type Scorm12ItemMutationUpsertArgs = {
  input?: InputMaybe<UpsertScoInput>;
};

export enum Scorm12_Entry {
  Abinitio = 'ABINITIO',
  Resume = 'RESUME'
}

export enum Scorm12_LessonStatus {
  Browsed = 'BROWSED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Incomplete = 'INCOMPLETE',
  Notattempted = 'NOTATTEMPTED',
  Passed = 'PASSED'
}

export enum Scorm12_TimeLimitAction {
  ContinueMessage = 'CONTINUE_MESSAGE',
  ContinueNoMessage = 'CONTINUE_NO_MESSAGE',
  ExitMessage = 'EXIT_MESSAGE',
  ExitNoMessage = 'EXIT_NO_MESSAGE'
}

export type ScosDto = {
  __typename?: 'ScosDto';
  createdDate: Scalars['Instant']['output'];
  dataFromLMS?: Maybe<Scalars['String']['output']>;
  deletedDate?: Maybe<Scalars['Instant']['output']>;
  description?: Maybe<LangString>;
  isDraft: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isTrackable: Scalars['Boolean']['output'];
  itemType?: Maybe<ItemType>;
  launchUri?: Maybe<Scalars['String']['output']>;
  manifestId?: Maybe<Scalars['String']['output']>;
  masteryScore?: Maybe<Scalars['Float']['output']>;
  maxTimeAlloed?: Maybe<Scalars['Duration']['output']>;
  mediaType?: Maybe<MediaType>;
  metadata?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  timeLimitAction: Scorm12_TimeLimitAction;
  title?: Maybe<LangString>;
  type?: Maybe<Scalars['String']['output']>;
  typicalLearningTime?: Maybe<Scalars['Duration']['output']>;
  updatedDate: Scalars['Instant']['output'];
  uuid: Scalars['UUID']['output'];
};

/** SelfRegistration */
export type SelfRegistrationGql = {
  __typename?: 'SelfRegistrationGQL';
  /** Expiration date of self registration link */
  expirationDate: Scalars['String']['output'];
  /** Number of groups assigned to self generation link */
  groupCount: Scalars['Int']['output'];
  /** Groups assigned to self generation link */
  groups: Array<Maybe<Group>>;
  /** Link for self registration */
  link: Scalars['String']['output'];
  /** Status of self registration link */
  status: Scalars['String']['output'];
  /** Title of self registration */
  title: Scalars['String']['output'];
  /** Uuid */
  uuid: Scalars['UUID']['output'];
  /** Number of whitelist domains assigned to self generation link */
  whiteListCount: Scalars['Int']['output'];
  /** Whitelist domains assigned to self generation link */
  whiteLists: Array<Maybe<Scalars['String']['output']>>;
};

export type SelfRegistrationInput = {
  groups?: InputMaybe<UpsertLinksInput>;
  idOrKey: IdOrKeyInput;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userStatus?: InputMaybe<UserStatus>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  whitelists?: InputMaybe<Scalars['String']['input']>;
};

/** GraphQl mutation for updating/upserting, acceping or denying, renew or delete Selfregistration data */
export type SelfRegistrationMutationGql = {
  __typename?: 'SelfRegistrationMutationGQL';
  acceptOrDenyUser: User;
  bulkAcceptOrDenyUser: Array<Maybe<User>>;
  renewOrDeleteLink: SelfRegistrationGql;
  upsert: SelfRegistrationGql;
};


/** GraphQl mutation for updating/upserting, acceping or denying, renew or delete Selfregistration data */
export type SelfRegistrationMutationGqlAcceptOrDenyUserArgs = {
  input: SelfRegistrationInput;
};


/** GraphQl mutation for updating/upserting, acceping or denying, renew or delete Selfregistration data */
export type SelfRegistrationMutationGqlBulkAcceptOrDenyUserArgs = {
  input: BulkAcceptanceListInput;
};


/** GraphQl mutation for updating/upserting, acceping or denying, renew or delete Selfregistration data */
export type SelfRegistrationMutationGqlRenewOrDeleteLinkArgs = {
  input: SelfRegistrationInput;
};


/** GraphQl mutation for updating/upserting, acceping or denying, renew or delete Selfregistration data */
export type SelfRegistrationMutationGqlUpsertArgs = {
  input: SelfRegistrationInput;
};

export type SetTemporaryPasswordInput = {
  idOrKey?: InputMaybe<IdOrKeyInput>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SystemBadgeTypesEnum {
  ActiveShopper = 'ACTIVE_SHOPPER',
  BadgeMaster = 'BADGE_MASTER',
  Champion = 'CHAMPION',
  Collector = 'COLLECTOR',
  FirstOrder = 'FIRST_ORDER',
  Hoarder = 'HOARDER',
  LoyalCustomer = 'LOYAL_CUSTOMER',
  Native = 'NATIVE',
  Newcomer = 'NEWCOMER',
  Pro = 'PRO',
  Resident = 'RESIDENT',
  Starter = 'STARTER',
  Visitor = 'VISITOR',
  X = 'X'
}

export type TaskDto = {
  __typename?: 'TaskDto';
  archivedDate?: Maybe<Scalars['Instant']['output']>;
  attachment?: Maybe<AttachmentInfo>;
  completionType?: Maybe<Scalars['String']['output']>;
  countOfCompletion?: Maybe<Scalars['Int']['output']>;
  countOfLearners?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<LangString>;
  group?: Maybe<LangString>;
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<LangString>;
  members?: Maybe<Array<Maybe<MembersDto>>>;
  title?: Maybe<LangString>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type TaskInput = {
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  idOrKey: IdOrKeyInput;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isTaskReset?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  memberUuid?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type TasksFiltersInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TopicsFiltersInput = {
  assignedCategoriesIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  maxMediaCount?: InputMaybe<Scalars['Int']['input']>;
  minMediaCount?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A unit */
export type Unit = {
  __typename?: 'Unit';
  /** color */
  color?: Maybe<Scalars['String']['output']>;
  /** Unit id to display */
  displayedId: Scalars['String']['output'];
  /** Defines number of groups per unit */
  groupCount: Scalars['Int']['output'];
  /** Unit groups */
  groups: Array<Maybe<GroupRefactored>>;
  id: Scalars['ID']['output'];
  /** Defines if unit is active */
  isActive: Scalars['Boolean']['output'];
  /** Is general unit */
  isGeneral: Scalars['Boolean']['output'];
  /** Is current user the unit manager */
  isUnitManager: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  /** Logo URL */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Media assigned to the group */
  media: Array<Maybe<Scorm12Course>>;
  /** Defines number of medias per unit */
  mediaCount: Scalars['Int']['output'];
  /** Defines name of the unit */
  name: Scalars['String']['output'];
  /** Defines number of users per unit */
  userCount: Scalars['Int']['output'];
  /** Unit users */
  users: Array<Maybe<User>>;
  uuid: Scalars['UUID']['output'];
};

/** GraphQl mutation for updating and adding Units */
export type UnitMutation = {
  __typename?: 'UnitMutation';
  delete: Array<Maybe<Unit>>;
  updateUnitStatus: Array<Maybe<Unit>>;
  upsert: Unit;
};


/** GraphQl mutation for updating and adding Units */
export type UnitMutationDeleteArgs = {
  unitUuids: Array<InputMaybe<Scalars['String']['input']>>;
};


/** GraphQl mutation for updating and adding Units */
export type UnitMutationUpdateUnitStatusArgs = {
  input: UpdateUnitStatusInput;
};


/** GraphQl mutation for updating and adding Units */
export type UnitMutationUpsertArgs = {
  input?: InputMaybe<AddUnitInput>;
};

export type UpdateCategoryMediasOrderInput = {
  categoryUuid?: InputMaybe<Scalars['String']['input']>;
  courseUuid?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
};

export type UpdateCourseEvaluationInput = {
  idOrKey: IdOrKeyInput;
  isAnonym: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateCourseFavouriteInput = {
  favourite: Scalars['Boolean']['input'];
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateGroupStatusInput = {
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  status: GroupStatus;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateMediaCategoriesInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  courseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMediaGroupsInput = {
  accessAfterUnit?: InputMaybe<RelativeTimeUnitEnum>;
  accessAfterValue?: InputMaybe<Scalars['Int']['input']>;
  accessDurationUnit?: InputMaybe<RelativeTimeUnitEnum>;
  accessDurationValue?: InputMaybe<Scalars['Int']['input']>;
  activateMedia?: InputMaybe<Scalars['Boolean']['input']>;
  assignmentType?: InputMaybe<AssignmentTypeEnum>;
  completionNotification?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfReminder?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  groups?: InputMaybe<UpsertLinksInput>;
  idOrKey: IdOrKeyInput;
  intervall?: InputMaybe<IntervallTypeEnum>;
  intervallEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  newCourseNotification?: InputMaybe<Scalars['Boolean']['input']>;
  roleLinks?: InputMaybe<Array<InputMaybe<UpsertRoleAssignmentInput>>>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateUnitStatusInput = {
  isActive: Scalars['Boolean']['input'];
  unitUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateUserGroupsInput = {
  groups?: InputMaybe<UpsertLinksInput>;
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateUserStatusInput = {
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  status: UserStatus;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UploadCourseInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UploadFileInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
};

/** Upload status */
export type Upload_Status = {
  __typename?: 'Upload_Status';
  /** Show upload status */
  isDeleted: Scalars['Boolean']['output'];
  /** Actual status of process */
  status: CourseUploadStatus;
  /** Number of courses to be uploaded in a process */
  totalToUpload: Scalars['Int']['output'];
  /** How many course are uploaded from latest process */
  totalUploaded: Scalars['Int']['output'];
};

export type UpsertBadgeInput = {
  badgeType: BadgeTypeEnum;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  idOrKey: IdOrKeyInput;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isEdit: Scalars['Boolean']['input'];
  isSystemBadge: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  seriesDe?: InputMaybe<Scalars['String']['input']>;
  seriesEn?: InputMaybe<Scalars['String']['input']>;
  systemBadgeTypes?: InputMaybe<SystemBadgeTypesEnum>;
  titleDe?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  uuidPrimary?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertBadgeNotificationsInput = {
  badgeId?: InputMaybe<Scalars['Int']['input']>;
  badgeType: BadgeTypeEnum;
  courseName?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  idOrKey: IdOrKeyInput;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  notificationShown?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertCategoryInput = {
  deleteFile?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<UpsertLangStringInput>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  name?: InputMaybe<UpsertLangStringInput>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertCertificateInput = {
  deleteFile?: InputMaybe<Scalars['Boolean']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  headingDe?: InputMaybe<Scalars['String']['input']>;
  headingEn?: InputMaybe<Scalars['String']['input']>;
  headingSw?: InputMaybe<Scalars['String']['input']>;
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  textDe?: InputMaybe<Scalars['String']['input']>;
  textEn?: InputMaybe<Scalars['String']['input']>;
  textSw?: InputMaybe<Scalars['String']['input']>;
  titleDe?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  titleSw?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypeEnum;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertCollectionOfStringInput = {
  add?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  remove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpsertConfigInput = {
  deleteFile?: InputMaybe<Scalars['Boolean']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertCourseInput = {
  badge?: InputMaybe<IdOrKeyInput>;
  categories?: InputMaybe<UpsertLinksInput>;
  certificate?: InputMaybe<IdOrKeyInput>;
  courseIdentifier?: InputMaybe<Scalars['String']['input']>;
  dashboardMode?: InputMaybe<DashboardMode>;
  deleteFile?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<UpsertLangStringInput>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  expirationDate?: InputMaybe<Scalars['Instant']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileDocument?: InputMaybe<Scalars['Upload']['input']>;
  fileSubtitle?: InputMaybe<Scalars['Upload']['input']>;
  fileVideo?: InputMaybe<Scalars['Upload']['input']>;
  idOrKey: IdOrKeyInput;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableByOthers?: InputMaybe<Scalars['Boolean']['input']>;
  isLearningPath?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<UpsertKeyedCollection2OfUpsertScoInput>;
  key?: InputMaybe<Scalars['Key']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<UpsertLangStringInput>;
  playOnLoop?: InputMaybe<Scalars['Boolean']['input']>;
  publishStatus?: InputMaybe<PublishStatus>;
  type?: InputMaybe<Scalars['String']['input']>;
  typicalLearningTime?: InputMaybe<Scalars['Duration']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertGroupInput = {
  idOrKey: IdOrKeyInput;
  isKeycloak?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  name?: InputMaybe<UpsertLangStringInput>;
  status: GroupStatus;
  unitId?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<UpsertLinksInput>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertGroupRoleInput = {
  roleLinks?: InputMaybe<Array<InputMaybe<UpsertRoleAssignmentInput>>>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertIconInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  idOrKey: IdOrKeyInput;
  isActive: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  titleDe?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertKeyedCollection2OfUpsertScoInput = {
  add?: InputMaybe<Array<InputMaybe<UpsertScoInput>>>;
  remove?: InputMaybe<Array<InputMaybe<IdOrKeyInput>>>;
  set?: InputMaybe<Array<InputMaybe<UpsertScoInput>>>;
};

export type UpsertLangStringInput = {
  add?: InputMaybe<Array<InputMaybe<KeyValueInput>>>;
  neutral?: InputMaybe<Scalars['String']['input']>;
  remove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<KeyValueInput>>>;
};

export type UpsertLauncherInput = {
  additionalConfiguration?: InputMaybe<Scalars['String']['input']>;
  aliasKey?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  contextKey?: InputMaybe<Scalars['String']['input']>;
  cssClasses?: InputMaybe<Scalars['String']['input']>;
  defaultHiddenValue?: InputMaybe<Scalars['Boolean']['input']>;
  hideForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  idOrKey: IdOrKeyInput;
  image?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelNeutral?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  showForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertLinksInput = {
  add?: InputMaybe<Array<InputMaybe<IdOrKeyInput>>>;
  remove?: InputMaybe<Array<InputMaybe<IdOrKeyInput>>>;
  set?: InputMaybe<Array<InputMaybe<IdOrKeyInput>>>;
};

export type UpsertMailTemplateInput = {
  additionalInfoDe?: InputMaybe<Scalars['String']['input']>;
  additionalInfoEn?: InputMaybe<Scalars['String']['input']>;
  additionalInfoSw?: InputMaybe<Scalars['String']['input']>;
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  mainTextDe?: InputMaybe<Scalars['String']['input']>;
  mainTextEn?: InputMaybe<Scalars['String']['input']>;
  mainTextSw?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<UpsertLangStringInput>;
  nameDE?: InputMaybe<Scalars['String']['input']>;
  nameEN?: InputMaybe<Scalars['String']['input']>;
  subjectDe?: InputMaybe<Scalars['String']['input']>;
  subjectEn?: InputMaybe<Scalars['String']['input']>;
  subjectSw?: InputMaybe<Scalars['String']['input']>;
  templateType: EmailTemplateEnum;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertNuggetInputsInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
  dataFromLMS?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<UpsertLangStringInput>;
  event?: InputMaybe<EventDtoInput>;
  idOrKey: IdOrKeyInput;
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isReusable?: InputMaybe<Scalars['Boolean']['input']>;
  itemIdentifier?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  key?: InputMaybe<Scalars['Key']['input']>;
  learningTime?: InputMaybe<Scalars['Duration']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<MediaType>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  removeIcon?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<UpsertLangStringInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  uploadFile?: InputMaybe<Scalars['Upload']['input']>;
  uploadIcon?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertOrgGroupsInput = {
  /** OrgGroup IdorKey */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ids or Keys for OrgGroup roles */
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpsertRef2Input = {
  idOrKey: IdOrKeyInput;
};

export type UpsertRoleAssignmentInput = {
  add?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  group: Scalars['String']['input'];
  remove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpsertRoleInput = {
  description?: InputMaybe<UpsertLangStringInput>;
  idOrKey: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  name?: InputMaybe<UpsertLangStringInput>;
  privilegeLinks?: InputMaybe<UpsertCollectionOfStringInput>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertScoInput = {
  courseLink?: InputMaybe<IdOrKeyInput>;
  dataFromLMS?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<UpsertLangStringInput>;
  idOrKey: IdOrKeyInput;
  key?: InputMaybe<Scalars['Key']['input']>;
  launchUri?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<UpsertLangStringInput>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertUserInput = {
  adminRole?: InputMaybe<Scalars['Boolean']['input']>;
  deleteFile?: InputMaybe<Scalars['Boolean']['input']>;
  deleteUser?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupsAndRoles?: InputMaybe<Scalars['String']['input']>;
  idOrKey: IdOrKeyInput;
  importStatus?: InputMaybe<Scalars['String']['input']>;
  importStatusOverwritten?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['Key']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roleLinks?: InputMaybe<Array<InputMaybe<UpsertRoleAssignmentInput>>>;
  status?: InputMaybe<UserStatus>;
  username?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** A User */
export type User = {
  __typename?: 'User';
  /** Admin role flag */
  admin: Scalars['Boolean']['output'];
  /** All groups */
  allGroups: Array<Maybe<Group>>;
  /** Assigned groups */
  assignedGroups: Scalars['Int']['output'];
  /** Badges accomplished from user */
  badges: Array<Maybe<Badges>>;
  /** Completed Badges */
  badgesCompleted: Scalars['Int']['output'];
  /** Certificates accomplished from user */
  certificates: Array<Maybe<Certificate>>;
  /** Completed certificates */
  certificatesCompleted: Scalars['Int']['output'];
  /** Defines email of the User */
  email: Scalars['String']['output'];
  /** External id */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Defines first name of the User */
  firstName: Scalars['String']['output'];
  /** Groups assigned to the user */
  groups: Array<Maybe<Group>>;
  /** Groups and roles assigned to the user */
  groupsAndRoles: Array<Maybe<UserAuthorizationGql>>;
  /** Groups not assigned to the user */
  groupsNotAssigned: Array<Maybe<Group>>;
  /** Image URL */
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Image base64 */
  imageBase64?: Maybe<Scalars['String']['output']>;
  /** Is user anonymized */
  isAnonymized: Scalars['Boolean']['output'];
  /** Education manager role flag */
  isEducationManager: Scalars['Boolean']['output'];
  /** Contact person (parent) role flag */
  isParent: Scalars['Boolean']['output'];
  /** Joined date */
  joinedDate?: Maybe<Scalars['String']['output']>;
  key: Scalars['Key']['output'];
  /** Defines last name of the User */
  lastName: Scalars['String']['output'];
  /** Defines the location */
  location: Scalars['String']['output'];
  /** Custom metadata of the User as a JSON object string */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Defines full name of the User */
  name: Scalars['String']['output'];
  /** Defines the phone */
  phone: Scalars['String']['output'];
  /** Associated Role to a Group + User. */
  roles: Array<Maybe<Role>>;
  scorm12EnrolledCourses: Array<Maybe<Scorm12EnrolledCourse>>;
  /** Associated self registration link title */
  selfRegistrationLinkTitle: Scalars['String']['output'];
  showDeadlinesAsAppointment: Scalars['Boolean']['output'];
  /** User status */
  status: UserStatus;
  /** Associated self registration link title */
  systemLanguage: Array<Maybe<Scalars['String']['output']>>;
  /** Defines the username */
  username: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};


/** A User */
export type UserScorm12EnrolledCoursesArgs = {
  filter?: InputMaybe<UserEnrolledCourseInput>;
};

export type UserAssignedContent = {
  __typename?: 'UserAssignedContent';
  completionDate?: Maybe<Scalars['Instant']['output']>;
  courseUuid: Scalars['UUID']['output'];
  endDate?: Maybe<Scalars['Instant']['output']>;
  /** The enrollment the user works in for this content (the one shown to the learner) */
  enrolledCourseUuid: Scalars['UUID']['output'];
  /** Groups the content is assigned through */
  groups: Array<Maybe<ContentGroup>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** False when every assignment of the content has been removed */
  isActiveAssignment: Scalars['Boolean']['output'];
  /** Typical learning time of the content */
  learningTime?: Maybe<Scalars['Duration']['output']>;
  mandatory: Scalars['Boolean']['output'];
  name: LangString;
  source: ContentAssignmentSource;
  startDate?: Maybe<Scalars['Instant']['output']>;
  state: AssignedContentState;
};

export type UserAuthorizationGql = {
  __typename?: 'UserAuthorizationGQL';
  authorizationLevel?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['Key']['output'];
  role?: Maybe<Scalars['String']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type UserBadge = {
  __typename?: 'UserBadge';
  badgeType: BadgeTypeEnum;
  /** Name of the content the badge was earned with (course badges) */
  contentName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Address to download the picture through the API; empty when the browser fetches it from imageUrl itself (UI-relative pictures) */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** When the badge was granted; empty for badges granted before this information was recorded */
  grantedDate?: Maybe<Scalars['Instant']['output']>;
  /** Address to show the picture: a web address, a path relative to the UI, or the API's badge picture endpoint */
  imageUrl?: Maybe<Scalars['String']['output']>;
  isSystemBadge: Scalars['Boolean']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type UserBadgesDto = {
  __typename?: 'UserBadgesDto';
  badgeId: Scalars['Int']['output'];
  badgeType?: Maybe<Scalars['String']['output']>;
  badgeTypeCount: Scalars['Int']['output'];
  courseName?: Maybe<LangString>;
  currentLevel: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UserCertificate = {
  __typename?: 'UserCertificate';
  contentName: LangString;
  courseUuid: Scalars['UUID']['output'];
  enrolledCourseUuid: Scalars['UUID']['output'];
  grantedDate?: Maybe<Scalars['Instant']['output']>;
  name: Scalars['String']['output'];
};

export type UserConnectionGql = {
  __typename?: 'UserConnectionGQL';
  edges: Array<UserEdgeGql>;
  nodes: Array<User>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

/** User Course Statistics */
export type UserCourseStatisticsGql = {
  __typename?: 'UserCourseStatisticsGQL';
  /** Activations of the course, one per group assignment or catalog booking */
  activations: Array<Maybe<UserDetailsStatisticsGql>>;
  /** Calls */
  calls: Scalars['Int']['output'];
  /** Completion date of the current activation */
  completion: Scalars['String']['output'];
  /** Course Item Identifier */
  courseItemIdentifier: Scalars['String']['output'];
  /** Course title */
  courseTitle: LangString;
  /** Groups the course is assigned through */
  groups: Array<Maybe<Group>>;
  /** ID */
  id: Scalars['String']['output'];
  /** Mandatory in at least one group */
  mandatory: Scalars['Boolean']['output'];
  /** result */
  results: Scalars['Float']['output'];
  /** Status of the current activation */
  status: Scalars['String']['output'];
};

export type UserDetails = {
  __typename?: 'UserDetails';
  /** Every content that is or has been assigned to the user, one entry per content */
  assignedContent: Array<Maybe<UserAssignedContent>>;
  /** Badges the user gained */
  badges: Array<Maybe<UserBadge>>;
  /** Certificates the user achieved: one per completed content that has a certificate */
  certificates: Array<Maybe<UserCertificate>>;
  /** Active groups the user belongs to, with the date the user was added, the user's roles and the number of contents assigned to the group */
  groups: Array<Maybe<UserGroupMembership>>;
  id: Scalars['ID']['output'];
  /** Notes about the user, visible to admins and education managers only */
  internalNotes?: Maybe<Scalars['String']['output']>;
  key: Scalars['Key']['output'];
  /** Start of the user's latest session recorded by sitos; empty when the user has not logged in since sessions are recorded */
  lastLogin?: Maybe<Scalars['Instant']['output']>;
  /** Distinct role keys of the user: global roles and the roles held in active groups */
  roles: Array<Maybe<Scalars['String']['output']>>;
  /** Sessions of the user recorded by sitos, newest first */
  sessions: Array<Maybe<UserSession>>;
  uuid: Scalars['UUID']['output'];
};

/** User Details Statistics */
export type UserDetailsStatisticsGql = {
  __typename?: 'UserDetailsStatisticsGQL';
  /** Calls */
  calls: Scalars['Int']['output'];
  /** Completion date */
  completion: Scalars['String']['output'];
  /** Contact roles */
  contactRoles: Scalars['String']['output'];
  /** Course Item Identifier */
  courseItemIdentifier: Scalars['String']['output'];
  /** Course title */
  courseTitle: LangString;
  /** Creation date */
  creationDate: Scalars['String']['output'];
  /** Current result */
  currentResult: Scalars['Float']['output'];
  /** End date */
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Group assigned */
  group?: Maybe<Group>;
  /** ID */
  id: Scalars['String']['output'];
  /** Intervall */
  intervall: Scalars['String']['output'];
  /** Mandatory flag */
  mandatory: Scalars['Boolean']['output'];
  /** Recurring flag */
  recurring: Scalars['Boolean']['output'];
  /** result */
  results: Scalars['Float']['output'];
  /** Start date */
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Status */
  status: Scalars['String']['output'];
};

export type UserDto = {
  __typename?: 'UserDto';
  authorizationTokenKey?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Instant']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['UUID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isAnonymized?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  scorm12EnrolledCourses?: Maybe<Array<Maybe<Scorm12EnrolledCourseDto>>>;
  status: UserStatus;
  statusDate?: Maybe<Scalars['Instant']['output']>;
  updatedDate?: Maybe<Scalars['Instant']['output']>;
  userSelfRegistrationId?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserEdgeGql = {
  __typename?: 'UserEdgeGQL';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserEnrolledCourseInput = {
  completionStatus: CourseCompletionStatus;
  courseLinks?: InputMaybe<Array<InputMaybe<IdOrKeyInput>>>;
};

export type UserGroupMembership = {
  __typename?: 'UserGroupMembership';
  /** When the user was added to the group; empty for memberships older than this information */
  addedDate?: Maybe<Scalars['Instant']['output']>;
  assignedContentCount: Scalars['Int']['output'];
  isGeneral: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roles: Array<Maybe<Scalars['String']['output']>>;
  unitName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutation = {
  __typename?: 'UserMutation';
  adminRights: User;
  anonymize: User;
  assignUnitManagers: Unit;
  bulkAnonymize: Array<Maybe<User>>;
  bulkRemove: Scalars['Boolean']['output'];
  bulkResendVerificationEmail: Scalars['Boolean']['output'];
  bulkUpdateGroups: Array<Maybe<User>>;
  bulkUpdateUserStatus: Array<Maybe<User>>;
  changeDeadLineViewModel: Scalars['Boolean']['output'];
  configureLanguage: User;
  importUsers: ImportUsers;
  insertUserIfNotExistsInSitos: AssignmentTokenDto;
  isEducationalManager: Scalars['Boolean']['output'];
  isLearner: Scalars['Boolean']['output'];
  promoteUser: User;
  remove: Scalars['Boolean']['output'];
  /** Removes a content the user got through a catalogue booking or a single assignment. Contents assigned through a group are removed by removing the user from the group */
  removeContentAssignment: Scalars['Boolean']['output'];
  removeRights: User;
  resendVerificationEmail: Scalars['Boolean']['output'];
  /** Mails the user a one-off link to set a new password, valid for 10 minutes. The admin never sees a password. Same action as 'forgot password' on the login page. */
  sendPasswordResetEmail: Scalars['Boolean']['output'];
  /** Sets a temporary password on the user's account. The password is not mailed to anyone; the user must choose a new one at next login. */
  setTemporaryPassword: Scalars['Boolean']['output'];
  /** Records activity in the current user's login session (History tab of the user details). Call it after login and periodically while the app is in use */
  trackSession: Scalars['Boolean']['output'];
  updateCountUserLogin: Scalars['Boolean']['output'];
  updateGroups: User;
  /** Sets the internal notes of a user (admins, and education managers for users of their groups). Empty text clears them */
  updateInternalNotes: Scalars['Boolean']['output'];
  /** Updates the metadata of a User with a JSON object string. Each key is added or its value replaced, a key set to null is removed, other keys stay unchanged. Without idOrKey the current User is updated, another User requires the CONFIGURE_ANY_COURSE privilege */
  updateMetadata: User;
  updateUserStatus: User;
  upsert: User;
  upsertGroupRoles: User;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationAdminRightsArgs = {
  input: UpsertUserInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationAnonymizeArgs = {
  input?: InputMaybe<UpsertRef2Input>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationAssignUnitManagersArgs = {
  input?: InputMaybe<AddUnitLearningManagersInput>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationBulkAnonymizeArgs = {
  input?: InputMaybe<BulkAnonymizeUserInput>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationBulkRemoveArgs = {
  input: BulkDeleteUserInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationBulkResendVerificationEmailArgs = {
  input?: InputMaybe<BulkResendVerificationEmailInput>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationBulkUpdateGroupsArgs = {
  input: BulkUpdateUserGroupsInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationBulkUpdateUserStatusArgs = {
  input: BulkUpdateUserStatusInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationConfigureLanguageArgs = {
  languages: Array<InputMaybe<Scalars['String']['input']>>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationImportUsersArgs = {
  input: ImportUserLogsInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationInsertUserIfNotExistsInSitosArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationIsEducationalManagerArgs = {
  role?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationIsLearnerArgs = {
  role?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationPromoteUserArgs = {
  input?: InputMaybe<PromoteUserInput>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationRemoveArgs = {
  input: UpsertRef2Input;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationRemoveContentAssignmentArgs = {
  courseIdOrKey: IdOrKeyInput;
  userIdOrKey: IdOrKeyInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationRemoveRightsArgs = {
  input?: InputMaybe<DeleteUnitLearningManagerInput>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationResendVerificationEmailArgs = {
  input?: InputMaybe<UpsertRef2Input>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationSendPasswordResetEmailArgs = {
  input: UpsertRef2Input;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationSetTemporaryPasswordArgs = {
  input: SetTemporaryPasswordInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationUpdateGroupsArgs = {
  input: UpdateUserGroupsInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationUpdateInternalNotesArgs = {
  idOrKey: IdOrKeyInput;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationUpdateMetadataArgs = {
  idOrKey?: InputMaybe<IdOrKeyInput>;
  metadata: Scalars['String']['input'];
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationUpdateUserStatusArgs = {
  input: UpdateUserStatusInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationUpsertArgs = {
  input: UpsertUserInput;
};


/** GraphQl mutation for updating/upserting, importing, removing and anonymizing Users */
export type UserMutationUpsertGroupRolesArgs = {
  input: UpsertGroupRoleInput;
};

export type UserNewsMutationGql = {
  __typename?: 'UserNewsMutationGQL';
  setIsRead: Scalars['Boolean']['output'];
};


export type UserNewsMutationGqlSetIsReadArgs = {
  input: IdOrKeyInput;
  isRead: Scalars['Boolean']['input'];
};

export enum UserProgressAssignmentSource {
  Catalogue = 'CATALOGUE',
  Group = 'GROUP',
  Manual = 'MANUAL'
}

export type UserProgressFilterInput = {
  assignedFrom?: InputMaybe<Scalars['Instant']['input']>;
  assignedTo?: InputMaybe<Scalars['Instant']['input']>;
  assignmentSources?: InputMaybe<Array<UserProgressAssignmentSource>>;
  completedFrom?: InputMaybe<Scalars['Instant']['input']>;
  completedTo?: InputMaybe<Scalars['Instant']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  lastViewFrom?: InputMaybe<Scalars['Instant']['input']>;
  lastViewTo?: InputMaybe<Scalars['Instant']['input']>;
  mediaTypes?: InputMaybe<Array<MediaType>>;
  progressMax?: InputMaybe<Scalars['Float']['input']>;
  progressMin?: InputMaybe<Scalars['Float']['input']>;
  scoreMax?: InputMaybe<Scalars['Float']['input']>;
  scoreMin?: InputMaybe<Scalars['Float']['input']>;
  statuses?: InputMaybe<Array<CourseCompletionStatus>>;
  timeSpentMinutesMax?: InputMaybe<Scalars['Int']['input']>;
  timeSpentMinutesMin?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** One page of the user progress report */
export type UserProgressPage = {
  __typename?: 'UserProgressPage';
  /** Rows of the requested page */
  items: Array<Maybe<UserProgressRow>>;
  /** KPI figures over all rows matching search and filter */
  summary: UserProgressSummary;
  /** Number of rows matching search and filter (all pages) */
  totalCount: Scalars['Int']['output'];
};

/** One learner and one content item of the user progress report */
export type UserProgressRow = {
  __typename?: 'UserProgressRow';
  /** Earliest assignment date of the visible activations */
  assignedDate?: Maybe<Scalars['Instant']['output']>;
  /** Distinct groups through which the content is assigned (visible activations) */
  assignedGroups: Scalars['Int']['output'];
  /** Assigned through the catalogue in at least one visible activation */
  catalog: Scalars['Boolean']['output'];
  /** Completion date of the current activation, null unless completed */
  completionDate?: Maybe<Scalars['Instant']['output']>;
  /** Course key */
  courseId: Scalars['String']['output'];
  courseUuid: Scalars['UUID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Group names as "Group (Unit)", sorted */
  groupNames: Array<Maybe<Scalars['String']['output']>>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Last time the learner opened the content, null if never */
  lastView?: Maybe<Scalars['Instant']['output']>;
  /** Assigned manually in at least one visible activation (neither group nor catalogue) */
  manual: Scalars['Boolean']['output'];
  /** Media type of the root SCO */
  mediaType: MediaType;
  /** Progress in percent (0..100), null when not measurable */
  progress?: Maybe<Scalars['Float']['output']>;
  /** Stable selection and export key: <userUuid>:<courseUuid> */
  rowId: Scalars['String']['output'];
  /** Mean score in percent (0..100) over the SCOs with a score, null when there is none */
  score?: Maybe<Scalars['Float']['output']>;
  /** Status of the learner's current activation */
  status: CourseCompletionStatus;
  /** Time spent in seconds, null when no time was recorded */
  timeSpentSeconds?: Maybe<Scalars['Int']['output']>;
  /** Title localized for the current user */
  title: Scalars['String']['output'];
  userUuid: Scalars['UUID']['output'];
};

export enum UserProgressSortField {
  AssignedDate = 'ASSIGNED_DATE',
  AssignedThrough = 'ASSIGNED_THROUGH',
  CompletionDate = 'COMPLETION_DATE',
  LastView = 'LAST_VIEW',
  MediaType = 'MEDIA_TYPE',
  Progress = 'PROGRESS',
  Score = 'SCORE',
  Status = 'STATUS',
  TimeSpent = 'TIME_SPENT',
  Title = 'TITLE',
  User = 'USER'
}

export type UserProgressSortInput = {
  direction: SortDirection;
  field: UserProgressSortField;
};

/** KPI figures of the user progress report */
export type UserProgressSummary = {
  __typename?: 'UserProgressSummary';
  /** Mean progress in percent over the matching rows that have a progress, null if none has */
  averageProgress?: Maybe<Scalars['Float']['output']>;
  /** Mean time spent in seconds over the matching rows that have a time, null if none has */
  averageTimeSeconds?: Maybe<Scalars['Int']['output']>;
  /** Matching rows with status completed */
  completed: Scalars['Int']['output'];
  /** Matching rows with status not started; completed + started + notStarted = totalCount */
  notStarted: Scalars['Int']['output'];
  /** Matching rows with status started */
  started: Scalars['Int']['output'];
};

export type UserSession = {
  __typename?: 'UserSession';
  durationSeconds: Scalars['Int']['output'];
  /** Last activity seen in the session */
  endDate: Scalars['Instant']['output'];
  startDate: Scalars['Instant']['output'];
};

/** To show data from attempt and sco in one object */
export type UserStaticsLesson = {
  __typename?: 'UserStaticsLesson';
  /** Shows how often the lesson was called by the learner */
  calls: Scalars['Int']['output'];
  /** Shows if lesson is optional or required for completion */
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** Shows when the lesson was last called */
  lastCall?: Maybe<Scalars['Instant']['output']>;
  /** Date of completion of lesson item */
  lessonCompletionDate?: Maybe<Scalars['Instant']['output']>;
  /** Lesson title */
  lessonTitle?: Maybe<LangString>;
  /** Parent title */
  parentTitle?: Maybe<LangString>;
  /** Result in % */
  resultInPercentage: Scalars['Float']['output'];
  /** Complete / Incomplete / Passed / Failed / not attempted */
  status: Scorm12_LessonStatus;
  /** Shows the amount of time spent by the learner on the lessons */
  timeSpent?: Maybe<Scalars['Duration']['output']>;
};

/** User Statistics */
export type UserStatisticsOverviewGql = {
  __typename?: 'UserStatisticsOverviewGQL';
  /** Number of completed courses */
  completedCourses: Scalars['Int']['output'];
  /** Firstname of the user */
  firstName: Scalars['String']['output'];
  /** Is user anonymized */
  isAnonymized: Scalars['Boolean']['output'];
  /** Last course call (Date and Time) */
  lastCourseCall: Scalars['String']['output'];
  /** Last course called (Coursename) */
  lastCourseCalledName?: Maybe<LangString>;
  /** Lastname of the user */
  lastName: Scalars['String']['output'];
  /** Number of assigned courses (a course assigned through several groups counts once) */
  numberOfEnrollments: Scalars['Int']['output'];
  /** Number of courses not started yet */
  openInProgressCourses: Scalars['Int']['output'];
  /** Assigned courses, one entry per course with its activations */
  userCourseStatistics: Array<Maybe<UserCourseStatisticsGql>>;
  /** Assigned courses */
  userDetailsStatistics: Array<Maybe<UserDetailsStatisticsGql>>;
  /** UUID */
  uuid: Scalars['UUID']['output'];
};

export enum UserStatus {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED',
  Pending = 'PENDING'
}

export type UsersFiltersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isEducationManager?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  maxJoinedDate?: InputMaybe<Scalars['Instant']['input']>;
  minGroups?: InputMaybe<Scalars['Int']['input']>;
  minJoinedDate?: InputMaybe<Scalars['Instant']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type UsersStatisticsFiltersInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Scalars['String']['input']>;
  lastCall?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maxAssignmentsCount?: InputMaybe<Scalars['Int']['input']>;
  maxCalledOnDate?: InputMaybe<Scalars['Instant']['input']>;
  maxCompletedCount?: InputMaybe<Scalars['Int']['input']>;
  maxNotStartedCount?: InputMaybe<Scalars['Int']['input']>;
  minAssignmentsCount?: InputMaybe<Scalars['Int']['input']>;
  minCalledOnDate?: InputMaybe<Scalars['Instant']['input']>;
  minCompletedCount?: InputMaybe<Scalars['Int']['input']>;
  minNotStartedCount?: InputMaybe<Scalars['Int']['input']>;
};

export type WidgetInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  idOrKey: IdOrKeyInput;
  isAdditional: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['Key']['input']>;
  position?: InputMaybe<PositionInput>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<UpsertLangStringInput>;
  type: WidgetType;
  userId?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

/** GraphQl mutation for updating/upserting and setting default Widgets */
export type WidgetMutation = {
  __typename?: 'WidgetMutation';
  upsert: Widgets;
  upsertAllWidgets: Array<Maybe<Widgets>>;
};


/** GraphQl mutation for updating/upserting and setting default Widgets */
export type WidgetMutationUpsertArgs = {
  input: WidgetInput;
};


/** GraphQl mutation for updating/upserting and setting default Widgets */
export type WidgetMutationUpsertAllWidgetsArgs = {
  inputs: Array<InputMaybe<WidgetInput>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum WidgetType {
  Calendar = 'CALENDAR',
  Completions = 'COMPLETIONS',
  CourseRecommendation = 'COURSE_RECOMMENDATION',
  GetBackIn = 'GET_BACK_IN',
  LastCompletions = 'LAST_COMPLETIONS',
  LearningActivity = 'LEARNING_ACTIVITY',
  MyCertificates = 'MY_CERTIFICATES',
  MyCourseHistory = 'MY_COURSE_HISTORY',
  NewestMembers = 'NEWEST_MEMBERS',
  News = 'NEWS',
  NewsFromTheCatalogue = 'NEWS_FROM_THE_CATALOGUE',
  QuickLinks = 'QUICK_LINKS',
  Welcome = 'WELCOME'
}

/** A widget */
export type Widgets = {
  __typename?: 'Widgets';
  /** Defines height of the widget */
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Defines isAdditional of the widget */
  isAdditional: Scalars['Boolean']['output'];
  key: Scalars['Key']['output'];
  position?: Maybe<Position>;
  /** Defines title of the widget */
  title: LangString;
  /** Defines type of the widget */
  type: WidgetType;
  uuid: Scalars['UUID']['output'];
  /** Defines width of the widget */
  width: Scalars['Float']['output'];
};

export type WidgetsConnectionGql = {
  __typename?: 'WidgetsConnectionGQL';
  edges: Array<WidgetsEdgeGql>;
  nodes: Array<Widgets>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WidgetsEdgeGql = {
  __typename?: 'WidgetsEdgeGQL';
  cursor: Scalars['String']['output'];
  node: Widgets;
};

/** Mutation for zulip chat */
export type ZulipChatMutation = {
  __typename?: 'ZulipChatMutation';
  createStream: ZulipStreamGql;
  deactivateUser: Scalars['Boolean']['output'];
  muteTopic: Scalars['Boolean']['output'];
  sendMessages: ZulipStreamGql;
};


/** Mutation for zulip chat */
export type ZulipChatMutationCreateStreamArgs = {
  input: ZulipStreamInput;
};


/** Mutation for zulip chat */
export type ZulipChatMutationDeactivateUserArgs = {
  deactivationNotificationComment?: InputMaybe<Scalars['String']['input']>;
  userEmail: Scalars['String']['input'];
};


/** Mutation for zulip chat */
export type ZulipChatMutationMuteTopicArgs = {
  courseUuid: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


/** Mutation for zulip chat */
export type ZulipChatMutationSendMessagesArgs = {
  input: ZulipMessageInput;
};

/** Zulip chat message */
export type ZulipMessageGql = {
  __typename?: 'ZulipMessageGQL';
  avatar?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isMine: Scalars['Boolean']['output'];
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderFullName: Scalars['String']['output'];
  timestamp: Scalars['Long']['output'];
  topic?: Maybe<Scalars['String']['output']>;
};

export type ZulipMessageInput = {
  courseUuid?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** Zulip chat stream */
export type ZulipStreamGql = {
  __typename?: 'ZulipStreamGQL';
  /** Messages in the stream */
  messages?: Maybe<Array<Maybe<ZulipMessageGql>>>;
  name: Scalars['String']['output'];
};

export type ZulipStreamInput = {
  courseUuid?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** Zulip chat message */
export type ZulipTopicGql = {
  __typename?: 'ZulipTopicGQL';
  name: Scalars['String']['output'];
};

export type GetPreferencesQueryVariables = Types.Exact<{
  moduleName?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPreferencesQuery = { __typename?: 'Query', modulePreferences?: { __typename?: 'QueryModulePreferenceGQL', modulePreferences?: Array<{ __typename?: 'Module_preference', key: string, value: string } | null> | null } | null };

export const GetPreferencesDocument = gql`
    query getPreferences($moduleName: String) {
  modulePreferences {
    modulePreferences(moduleName: $moduleName) {
      key
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPreferencesGQL extends Apollo.Query<GetPreferencesQuery, GetPreferencesQueryVariables> {
    document = GetPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }